// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Robitest onboarding wizard — presentation layer (loaded after wizard.css).
   Everything is token-driven so light/dark follow html[data-theme].
   Spacing scale: 4 / 8 / 12 / 16 / 20 / 24 / 32 / 40 / 48
   ========================================================================== */

.wizard-layout,
.ob-modal-root {
  --ob-radius-sm: 8px;
  --ob-radius: 10px;
  --ob-radius-lg: 14px;
  --ob-radius-xl: 16px;
  --ob-header-h: 60px;
  --ob-pad-x: 32px;
  --ob-ease: cubic-bezier(0.2, 0, 0, 1);
  --ob-dur: 180ms;
  --ob-field-h: 42px;
  --ob-surface: var(--surface);
  --ob-surface-sunken: var(--bg-tertiary);
  --ob-on-primary: #ffffff;
}

/* --------------------------------------------------------------------------
   Layout: the wizard is its own scroll container (html/body are locked).
   -------------------------------------------------------------------------- */
.wizard-layout {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 14px;
  line-height: 1.5;
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb) transparent;
}

.wizard-layout::-webkit-scrollbar { width: 10px; }
.wizard-layout::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: 999px;
  border: 3px solid var(--bg-primary);
}

.wizard-layout .wizard-header {
  position: sticky;
  top: 0;
  z-index: 40;
  flex: none;
  height: var(--ob-header-h);
  padding: 0;
  background: var(--bg-primary);
  border-bottom: 1px solid var(--border);
  box-shadow: none;
  backdrop-filter: none;
}

.wizard-layout .wizard-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
  padding: 0 24px;
}

.wizard-layout .wizard-logo {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.wizard-layout .wizard-logo img {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.wizard-layout .wizard-logo-text {
  font-size: 16px;
  font-weight: 650;
  letter-spacing: -0.01em;
  color: var(--text-primary);
  background: none;
  -webkit-text-fill-color: currentColor;
}

.wizard-layout .ob-header-tag {
  padding: 2px 8px;
  border: 1px solid var(--border);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-muted);
}

.wizard-layout .wizard-header-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.wizard-layout .wizard-exit-btn,
.wizard-layout .wizard-save-exit-btn,
.wizard-layout .wizard-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 12px;
  border: 1px solid var(--border);
  border-radius: var(--ob-radius-sm);
  background: transparent;
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  box-shadow: none;
  transition: background-color var(--ob-dur) var(--ob-ease), color var(--ob-dur) var(--ob-ease),
    border-color var(--ob-dur) var(--ob-ease);
}

.wizard-layout .wizard-exit-btn:hover,
.wizard-layout .wizard-save-exit-btn:hover,
.wizard-layout .wizard-back-btn:hover {
  background: var(--surface-hover);
  border-color: var(--border-strong);
  color: var(--text-primary);
  transform: none;
}

.wizard-layout .wizard-main {
  flex: 1 0 auto;
  display: block;
  max-height: none;
  min-height: 0;
  overflow: visible;
  padding: 0 24px;
  background: transparent;
}

.wizard-layout .wizard-container {
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 0 40px;
}

.wizard-layout .wizard-footer {
  flex: none;
  padding: 16px 24px;
  border-top: 1px solid var(--border-subtle);
  background: transparent;
  text-align: center;
}

.wizard-layout .wizard-footer p {
  margin: 0;
  font-size: 12px;
  color: var(--text-muted);
}

/* --------------------------------------------------------------------------
   Stepper
   -------------------------------------------------------------------------- */
.ob-stepper {
  position: sticky;
  top: var(--ob-header-h);
  z-index: 30;
  margin: 0 0 20px;
  padding: 16px 0 12px;
  background: var(--bg-primary);
}

.ob-stepper__summary {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.ob-stepper__count {
  font-size: 13px;
  color: var(--text-muted);
  white-space: nowrap;
}

.ob-stepper__count strong {
  color: var(--text-primary);
  font-weight: 600;
}

.ob-stepper__percent {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

.ob-stepper__bar {
  height: 3px;
  margin-bottom: 12px;
  border-radius: 999px;
  background: var(--border-subtle);
  overflow: hidden;
}

.ob-stepper__bar-fill {
  height: 100%;
  border-radius: inherit;
  background: var(--primary);
  transition: width 250ms var(--ob-ease);
}

.ob-stepper__viewport {
  position: relative;
}

.ob-stepper__viewport::before,
.ob-stepper__viewport::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 32px;
  pointer-events: none;
  opacity: 0;
  transition: opacity var(--ob-dur) var(--ob-ease);
  z-index: 1;
}

.ob-stepper__viewport::before {
  left: 0;
  background: linear-gradient(to right, var(--bg-primary), transparent);
}

.ob-stepper__viewport::after {
  right: 0;
  background: linear-gradient(to left, var(--bg-primary), transparent);
}

.ob-stepper__viewport.has-left::before,
.ob-stepper__viewport.has-right::after {
  opacity: 1;
}

.ob-stepper__track {
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 2px;
  list-style: none;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.ob-stepper__track::-webkit-scrollbar {
  display: none;
}

.ob-stepper__item {
  display: flex;
  align-items: center;
  flex: none;
  gap: 4px;
}

.ob-step {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 34px;
  padding: 0 12px 0 5px;
  border: 1px solid transparent;
  border-radius: 999px;
  background: transparent;
  color: var(--text-muted);
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  cursor: default;
  transition: background-color var(--ob-dur) var(--ob-ease), color var(--ob-dur) var(--ob-ease),
    border-color var(--ob-dur) var(--ob-ease);
}

.ob-step__dot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 24px;
  height: 24px;
  border: 1.5px solid var(--border-strong);
  border-radius: 50%;
  background: var(--surface);
  color: var(--text-muted);
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.ob-step.is-complete {
  color: var(--text-secondary);
}

.ob-step.is-complete .ob-step__dot {
  border-color: var(--primary);
  background: var(--primary);
  color: var(--ob-on-primary);
}

.ob-step.is-current {
  border-color: color-mix(in srgb, var(--primary) 35%, transparent);
  background: var(--primary-muted);
  color: var(--text-primary);
  font-weight: 600;
}

.ob-step.is-current .ob-step__dot {
  border: 2px solid var(--primary);
  background: var(--surface);
  color: var(--primary);
}

.ob-step.is-clickable {
  cursor: pointer;
}

.ob-step.is-clickable:hover {
  background: var(--surface-hover);
  color: var(--text-primary);
}

.ob-step:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus);
}

.ob-stepper__sep {
  flex: none;
  width: 16px;
  height: 1.5px;
  border-radius: 999px;
  background: var(--border);
}

.ob-stepper__sep.is-complete {
  background: var(--primary);
}

/* --------------------------------------------------------------------------
   Step surface (one primary card per step)
   -------------------------------------------------------------------------- */
.wizard-layout .wizard-card {
  position: relative;
  max-width: none;
  margin: 0;
  padding: 0;
  border: 1px solid var(--border);
  border-radius: var(--ob-radius-xl);
  background: var(--ob-surface);
  box-shadow: var(--shadow-xs);
  overflow: visible;
  animation: ob-enter 220ms var(--ob-ease) both;
}

.wizard-layout .wizard-card-header {
  margin: 0;
  padding: 28px var(--ob-pad-x) 0;
  border: 0;
  background: none;
  text-align: left;
}

.wizard-layout .wizard-card-title {
  margin: 0;
  font-size: 26px;
  font-weight: 650;
  line-height: 1.25;
  letter-spacing: -0.015em;
  color: var(--text-primary);
  background: none;
  -webkit-text-fill-color: currentColor;
}

.wizard-layout .wizard-card-subtitle {
  max-width: 720px;
  margin: 6px 0 0;
  font-size: 15px;
  line-height: 1.55;
  color: var(--text-secondary);
}

.wizard-layout .wizard-card-content {
  padding: 24px var(--ob-pad-x) 32px;
  background: none;
}

/* Sticky action footer (bleeds to card edges) */
.wizard-layout .wizard-card-content > .wizard-actions,
.wizard-layout .wizard-card-content > .wizard-workspace-actions,
.wizard-layout .wizard-card-content > .wizard-project-actions,
.wizard-layout .wizard-card-content > .ob-actions {
  position: sticky;
  bottom: 0;
  z-index: 20;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin: 32px calc(-1 * var(--ob-pad-x)) -32px;
  padding: 16px var(--ob-pad-x);
  border-top: 1px solid var(--border);
  border-radius: 0 0 var(--ob-radius-xl) var(--ob-radius-xl);
  background: var(--ob-surface);
}

.wizard-layout .wizard-actions,
.wizard-layout .wizard-workspace-actions,
.wizard-layout .wizard-project-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.wizard-layout .wizard-actions > .wizard-btn-secondary:first-child,
.wizard-layout .wizard-workspace-actions > .back,
.wizard-layout .wizard-project-actions > .back,
.wizard-layout .ob-actions > .ob-actions__start {
  margin-right: auto;
}

.wizard-layout .wizard-actions-next-only {
  justify-content: flex-end;
}

/* --------------------------------------------------------------------------
   Buttons
   -------------------------------------------------------------------------- */
.ob-btn,
.wizard-layout .wizard-btn,
.wizard-layout .wizard-workspace-actions > button,
.wizard-layout .wizard-project-actions button,
.wizard-layout .wizard-workspace-edit-btn,
.wizard-layout .wizard-project-edit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  min-width: 0;
  padding: 0 18px;
  border: 1px solid transparent;
  border-radius: var(--ob-radius);
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
  box-shadow: none;
  transform: none;
  transition: background-color var(--ob-dur) var(--ob-ease), border-color var(--ob-dur) var(--ob-ease),
    color var(--ob-dur) var(--ob-ease), box-shadow var(--ob-dur) var(--ob-ease), opacity var(--ob-dur) var(--ob-ease);
}

.ob-btn:focus-visible,
.wizard-layout .wizard-btn:focus-visible,
.wizard-layout .wizard-workspace-actions > button:focus-visible,
.wizard-layout .wizard-project-actions button:focus-visible,
.wizard-layout .wizard-workspace-edit-btn:focus-visible,
.wizard-layout .wizard-project-edit-btn:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus);
}

.ob-btn:disabled,
.wizard-layout .wizard-btn:disabled,
.wizard-layout .wizard-workspace-actions > button:disabled,
.wizard-layout .wizard-project-actions button:disabled,
.wizard-layout .wizard-workspace-edit-btn:disabled,
.wizard-layout .wizard-project-edit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* Primary */
.ob-btn--primary,
.wizard-layout .wizard-btn-primary,
.wizard-layout .wizard-workspace-actions > .primary,
.wizard-layout .wizard-project-actions .primary,
.wizard-layout .wizard-workspace-edit-btn.primary,
.wizard-layout .wizard-project-edit-btn.primary {
  background: var(--primary);
  border-color: var(--primary);
  color: var(--ob-on-primary);
}

.ob-btn--primary:hover:not(:disabled),
.wizard-layout .wizard-btn-primary:hover:not(:disabled),
.wizard-layout .wizard-workspace-actions > .primary:hover:not(:disabled),
.wizard-layout .wizard-project-actions .primary:hover:not(:disabled),
.wizard-layout .wizard-workspace-edit-btn.primary:hover:not(:disabled),
.wizard-layout .wizard-project-edit-btn.primary:hover:not(:disabled) {
  background: var(--primary-hover);
  border-color: var(--primary-hover);
  color: var(--ob-on-primary);
  transform: none;
  box-shadow: none;
}

/* Secondary */
.ob-btn--secondary,
.wizard-layout .wizard-btn-secondary,
.wizard-layout .wizard-workspace-actions > .back,
.wizard-layout .wizard-project-actions .back,
.wizard-layout .wizard-project-actions .secondary,
.wizard-layout .wizard-workspace-edit-btn,
.wizard-layout .wizard-project-edit-btn,
.wizard-layout .wizard-workspace-edit-btn.secondary,
.wizard-layout .wizard-project-edit-btn.secondary {
  background: var(--surface);
  border-color: var(--border-strong);
  color: var(--text-primary);
}

.ob-btn--secondary:hover:not(:disabled),
.wizard-layout .wizard-btn-secondary:hover:not(:disabled),
.wizard-layout .wizard-workspace-actions > .back:hover:not(:disabled),
.wizard-layout .wizard-project-actions .back:hover:not(:disabled),
.wizard-layout .wizard-project-actions .secondary:hover:not(:disabled),
.wizard-layout .wizard-workspace-edit-btn:not(.primary):hover:not(:disabled),
.wizard-layout .wizard-project-edit-btn:not(.primary):hover:not(:disabled) {
  background: var(--surface-hover);
  border-color: var(--border-strong);
  color: var(--text-primary);
  transform: none;
}

/* Ghost / tertiary */
.ob-btn--ghost {
  background: transparent;
  border-color: transparent;
  color: var(--text-secondary);
}

.ob-btn--ghost:hover:not(:disabled) {
  background: var(--surface-hover);
  color: var(--text-primary);
}

/* Destructive */
.ob-btn--danger {
  background: var(--danger);
  border-color: var(--danger);
  color: #ffffff;
}

.ob-btn--danger:hover:not(:disabled) {
  background: color-mix(in srgb, var(--danger) 88%, #000);
  border-color: color-mix(in srgb, var(--danger) 88%, #000);
}

.ob-btn--sm,
.wizard-layout .wizard-workspace-edit-btn,
.wizard-layout .wizard-project-edit-btn {
  height: 32px;
  padding: 0 12px;
  font-size: 13px;
  border-radius: var(--ob-radius-sm);
}

.ob-btn--block {
  width: 100%;
}

.ob-btn--icon {
  width: 32px;
  height: 32px;
  padding: 0;
}

.ob-spinner,
.wizard-layout .spinner-small {
  display: inline-block;
  flex: none;
  width: 14px;
  height: 14px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: ob-spin 0.7s linear infinite;
}

.ob-spinner--lg {
  width: 28px;
  height: 28px;
  border-width: 3px;
  color: var(--primary);
}

/* Inline edit headers (Step 2 / Step 3) */
.wizard-layout .wizard-workspace-edit-header,
.wizard-layout .wizard-project-section-header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin: 0 0 16px;
  padding: 0;
  border: 0;
  background: none;
}

.wizard-layout .wizard-workspace-edit-actions,
.wizard-layout .wizard-project-edit-actions {
  display: inline-flex;
  gap: 8px;
}

/* --------------------------------------------------------------------------
   Forms
   -------------------------------------------------------------------------- */
.wizard-layout .wizard-form-row,
.wizard-layout .wizard-workspace-form,
.ob-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px 24px;
  margin: 0 0 20px;
}

.wizard-layout .wizard-form-row > .wizard-form-group,
.wizard-layout .wizard-workspace-form > .wizard-workspace-form-group {
  margin: 0;
}

.ob-col-span-2 {
  grid-column: 1 / -1;
}

.wizard-layout .wizard-form-group,
.wizard-layout .wizard-workspace-form-group,
.ob-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  margin: 0 0 20px;
}

.wizard-layout .wizard-form-label,
.wizard-layout .wizard-workspace-form-group > label,
.ob-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  font-size: 13.5px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--text-primary);
}

.wizard-layout .required,
.ob-required {
  color: var(--danger);
  font-weight: 600;
}

.ob-optional {
  font-weight: 500;
  color: var(--text-muted);
}

.wizard-layout .wizard-form-help,
.wizard-layout .wizard-workspace-form-group > p:not(.error),
.ob-help {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.45;
  color: var(--text-muted);
}

.wizard-layout .wizard-form-error,
.wizard-layout .wizard-workspace-form-group > p.error,
.ob-error {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.45;
  color: var(--danger);
}

.wizard-layout .wizard-form-input,
.wizard-layout .wizard-form-select,
.wizard-layout .wizard-form-textarea,
.wizard-layout .wizard-workspace-form-group > input,
.wizard-layout .wizard-workspace-form-group > select,
.ob-input {
  width: 100%;
  height: var(--ob-field-h);
  padding: 0 12px;
  border: 1px solid var(--input-border);
  border-radius: var(--ob-radius);
  background: var(--input-background);
  color: var(--text-primary);
  font-family: inherit;
  font-size: 14px;
  line-height: 1.4;
  box-shadow: none;
  transition: border-color var(--ob-dur) var(--ob-ease), box-shadow var(--ob-dur) var(--ob-ease),
    background-color var(--ob-dur) var(--ob-ease);
}

.wizard-layout .wizard-form-textarea,
.wizard-layout textarea.ob-input {
  height: auto;
  min-height: 96px;
  padding: 10px 12px;
  resize: vertical;
}

.wizard-layout .wizard-form-input::placeholder,
.wizard-layout .wizard-form-textarea::placeholder,
.wizard-layout .wizard-workspace-form-group > input::placeholder,
.ob-input::placeholder {
  color: var(--input-placeholder);
}

.wizard-layout .wizard-form-input:hover:not(:disabled),
.wizard-layout .wizard-form-select:hover:not(:disabled),
.wizard-layout .wizard-workspace-form-group > input:hover:not(:disabled),
.ob-input:hover:not(:disabled) {
  border-color: var(--border-strong);
}

.wizard-layout .wizard-form-input:focus,
.wizard-layout .wizard-form-select:focus,
.wizard-layout .wizard-form-textarea:focus,
.wizard-layout .wizard-workspace-form-group > input:focus,
.wizard-layout .wizard-workspace-form-group > select:focus,
.ob-input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: var(--shadow-focus);
}

.wizard-layout .wizard-form-input.error,
.wizard-layout .wizard-form-select.error,
.ob-input.is-invalid {
  border-color: var(--danger);
}

.wizard-layout .wizard-form-input:disabled,
.wizard-layout .wizard-form-select:disabled,
.wizard-layout .wizard-workspace-form-group > input:disabled,
.wizard-layout .wizard-workspace-form-group > select:disabled,
.ob-input:disabled {
  background: var(--surface-disabled);
  color: var(--text-secondary);
  cursor: not-allowed;
  opacity: 1;
}

.ob-input-group {
  display: flex;
  gap: 8px;
  align-items: stretch;
}

.ob-input-group > .ob-input {
  flex: 1 1;
  min-width: 0;
}

.ob-input-group > .ob-btn {
  height: var(--ob-field-h);
  flex: none;
}

.ob-field-hint-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

/* --------------------------------------------------------------------------
   Custom select (listbox)
   -------------------------------------------------------------------------- */
.ob-select {
  position: relative;
  width: 100%;
  min-width: 0;
}

.ob-select__trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  height: var(--ob-field-h);
  padding: 0 10px 0 12px;
  border: 1px solid var(--input-border);
  border-radius: var(--ob-radius);
  background: var(--input-background);
  color: var(--text-primary);
  font-family: inherit;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
  transition: border-color var(--ob-dur) var(--ob-ease), box-shadow var(--ob-dur) var(--ob-ease);
}

.ob-select__trigger:hover:not(:disabled) {
  border-color: var(--border-strong);
}

.ob-select__trigger:focus-visible,
.ob-select.is-open .ob-select__trigger {
  outline: none;
  border-color: var(--primary);
  box-shadow: var(--shadow-focus);
}

.ob-select__trigger:disabled {
  background: var(--surface-disabled);
  color: var(--text-secondary);
  cursor: not-allowed;
}

.ob-select.is-invalid .ob-select__trigger {
  border-color: var(--danger);
}

.ob-select__value {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ob-select__value.is-placeholder {
  color: var(--input-placeholder);
}

.ob-select__chevron {
  flex: none;
  color: var(--text-muted);
  transition: transform var(--ob-dur) var(--ob-ease);
}

.ob-select.is-open .ob-select__chevron {
  transform: rotate(180deg);
}

.ob-select__menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 60;
  max-height: 280px;
  margin: 0;
  padding: 6px;
  overflow-y: auto;
  list-style: none;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--surface-raised);
  box-shadow: var(--shadow-lg);
  animation: ob-pop 140ms var(--ob-ease) both;
  scrollbar-width: thin;
}

.ob-select__menu.is-up {
  top: auto;
  bottom: calc(100% + 6px);
}

.ob-select__option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 10px;
  border-radius: var(--ob-radius-sm);
  color: var(--text-primary);
  font-size: 14px;
  line-height: 1.35;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.ob-select__option.is-active {
  background: var(--surface-hover);
}

.ob-select__option.is-selected {
  color: var(--primary);
  font-weight: 600;
}

.ob-select__option.is-placeholder {
  color: var(--text-muted);
}

.ob-select__option[aria-disabled='true'] {
  color: var(--text-muted);
  cursor: not-allowed;
  opacity: 0.6;
}

.ob-select__option-hint {
  font-size: 11.5px;
  font-weight: 500;
  color: var(--text-muted);
}

.ob-select__empty {
  padding: 10px;
  font-size: 13px;
  color: var(--text-muted);
}

/* --------------------------------------------------------------------------
   Sections / grouping inside the single step surface
   -------------------------------------------------------------------------- */
.ob-section + .ob-section {
  margin-top: 28px;
  padding-top: 28px;
  border-top: 1px solid var(--border);
}

.ob-section__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.ob-section__title {
  margin: 0;
  font-size: 15px;
  font-weight: 650;
  line-height: 1.4;
  color: var(--text-primary);
}

.ob-section__desc {
  margin: 4px 0 0;
  font-size: 13.5px;
  line-height: 1.5;
  color: var(--text-secondary);
}

.ob-divider {
  height: 1px;
  margin: 24px 0;
  border: 0;
  background: var(--border);
}

.ob-muted {
  color: var(--text-muted);
}

.ob-empty-hint {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: var(--ob-field-h);
  margin-top: 26px;
  padding: 0 12px;
  border: 1px dashed var(--border);
  border-radius: var(--ob-radius);
  font-size: 13px;
  color: var(--text-muted);
}

/* --------------------------------------------------------------------------
   Selection cards (intent, source, tool, mode)
   -------------------------------------------------------------------------- */
.ob-choice-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
}

.ob-choice-grid--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.ob-choice-grid--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.ob-choice {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 20px;
  border: 1px solid var(--border);
  border-radius: var(--ob-radius-lg);
  background: var(--surface);
  color: var(--text-primary);
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: border-color var(--ob-dur) var(--ob-ease), background-color var(--ob-dur) var(--ob-ease),
    box-shadow var(--ob-dur) var(--ob-ease);
}

.ob-choice:hover:not(.is-disabled):not(:disabled) {
  border-color: var(--border-strong);
  background: var(--surface-hover);
}

.ob-choice:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus);
}

.ob-choice.is-selected {
  border-color: var(--primary);
  background: var(--primary-subtle);
  box-shadow: inset 0 0 0 1px var(--primary);
}

.ob-choice.is-selected:hover:not(.is-disabled) {
  border-color: var(--primary);
  background: var(--primary-subtle);
}

.ob-choice.is-disabled,
.ob-choice:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.ob-choice--compact {
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
}

.ob-choice__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 40px;
  height: 40px;
  border-radius: var(--ob-radius);
  background: var(--primary-muted);
  color: var(--primary);
}

.ob-choice__icon img {
  width: 22px;
  height: 22px;
  object-fit: contain;
}

.ob-choice__icon--success { background: var(--success-muted); color: var(--success); }
.ob-choice__icon--warning { background: var(--warning-muted); color: var(--warning); }
.ob-choice__icon--accent { background: var(--accent-muted); color: var(--accent); }
.ob-choice__icon--danger { background: var(--danger-muted); color: var(--danger); }

.ob-choice__body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.ob-choice__title {
  margin: 0;
  padding-right: 72px;
  font-size: 15px;
  font-weight: 650;
  line-height: 1.35;
  color: var(--text-primary);
}

.ob-choice--compact .ob-choice__title {
  padding-right: 24px;
  font-size: 14px;
}

.ob-choice__desc {
  margin: 0;
  font-size: 13.5px;
  line-height: 1.5;
  color: var(--text-secondary);
}

.ob-choice__list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 8px 0 0;
  padding: 0;
  list-style: none;
}

.ob-choice__list li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13px;
  line-height: 1.45;
  color: var(--text-secondary);
}

.ob-choice__list li svg {
  flex: none;
  margin-top: 2px;
  color: var(--success);
}

.ob-choice__list li.is-warning,
.ob-choice__list li.is-warning svg {
  color: var(--warning);
}

.ob-choice__badges {
  position: absolute;
  top: 16px;
  right: 16px;
  display: inline-flex;
  gap: 6px;
}

.ob-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  font-size: 11.5px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}

.ob-badge--primary { background: var(--primary-muted); color: var(--primary); }
.ob-badge--success { background: var(--success-muted); color: var(--success); }
.ob-badge--warning { background: var(--warning-muted); color: var(--warning); }
.ob-badge--info { background: var(--info-muted); color: var(--info); }

.ob-choice__check {
  position: absolute;
  top: 16px;
  right: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--primary);
  color: var(--ob-on-primary);
}

.ob-choice__check + .ob-choice__badges {
  right: 46px;
}

/* --------------------------------------------------------------------------
   Alerts
   -------------------------------------------------------------------------- */
.ob-alert {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 0 0 20px;
  padding: 12px 14px;
  border: 1px solid color-mix(in srgb, var(--ob-alert-color, var(--info)) 30%, transparent);
  border-radius: 12px;
  background: color-mix(in srgb, var(--ob-alert-color, var(--info)) 9%, var(--surface));
  color: var(--text-primary);
  font-size: 13.5px;
  line-height: 1.5;
}

.ob-alert--info { --ob-alert-color: var(--info); }
.ob-alert--success { --ob-alert-color: var(--success); }
.ob-alert--warning { --ob-alert-color: var(--warning); }
.ob-alert--danger { --ob-alert-color: var(--danger); }
.ob-alert--neutral { --ob-alert-color: var(--text-muted); }

.ob-alert__icon {
  flex: none;
  margin-top: 1px;
  color: var(--ob-alert-color, var(--info));
}

.ob-alert__body {
  flex: 1 1;
  min-width: 0;
  color: var(--text-secondary);
}

.ob-alert__title {
  margin: 0 0 2px;
  font-size: 13.5px;
  font-weight: 650;
  color: var(--text-primary);
}

.ob-alert__body p {
  margin: 0;
}

.ob-alert__action {
  flex: none;
  align-self: center;
}

/* --------------------------------------------------------------------------
   Disclosure (expandable help panel)
   -------------------------------------------------------------------------- */
.ob-disclosure {
  margin-top: 24px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--ob-surface-sunken);
}

.ob-disclosure > summary {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  list-style: none;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--text-primary);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 12px;
}

.ob-disclosure > summary::-webkit-details-marker {
  display: none;
}

.ob-disclosure > summary:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus);
}

.ob-disclosure__icon {
  flex: none;
  color: var(--primary);
}

.ob-disclosure__chevron {
  margin-left: auto;
  color: var(--text-muted);
  transition: transform var(--ob-dur) var(--ob-ease);
}

.ob-disclosure[open] .ob-disclosure__chevron {
  transform: rotate(180deg);
}

.ob-disclosure__content {
  padding: 0 14px 14px 40px;
  font-size: 13.5px;
  line-height: 1.6;
  color: var(--text-secondary);
}

.ob-disclosure__content p {
  margin: 0 0 8px;
}

.ob-disclosure__content ul {
  margin: 0 0 8px;
  padding-left: 18px;
}

.ob-disclosure__content li + li {
  margin-top: 2px;
}

.ob-disclosure__content strong {
  color: var(--text-primary);
}

/* --------------------------------------------------------------------------
   Dropzone + file list
   -------------------------------------------------------------------------- */
.ob-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 28px 24px;
  border: 1.5px dashed var(--border-strong);
  border-radius: var(--ob-radius-lg);
  background: var(--ob-surface-sunken);
  color: var(--text-primary);
  text-align: center;
  cursor: pointer;
  transition: border-color var(--ob-dur) var(--ob-ease), background-color var(--ob-dur) var(--ob-ease);
}

.ob-dropzone:hover:not(.is-disabled),
.ob-dropzone.is-dragging {
  border-color: var(--primary);
  background: var(--primary-subtle);
}

.ob-dropzone:focus-visible {
  outline: none;
  border-color: var(--primary);
  box-shadow: var(--shadow-focus);
}

.ob-dropzone.is-disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.ob-dropzone.is-invalid {
  border-color: var(--danger);
}

.ob-dropzone__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-bottom: 4px;
  border-radius: 12px;
  background: var(--primary-muted);
  color: var(--primary);
}

.ob-dropzone.has-files .ob-dropzone__icon {
  background: var(--success-muted);
  color: var(--success);
}

.ob-dropzone__title {
  margin: 0;
  font-size: 14.5px;
  font-weight: 600;
  color: var(--text-primary);
}

.ob-dropzone__title span {
  color: var(--primary);
}

.ob-dropzone__hint {
  margin: 0;
  font-size: 13px;
  color: var(--text-muted);
}

.ob-dropzone__formats {
  display: inline-flex;
  gap: 6px;
  margin-top: 4px;
}

.ob-file-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
}

.ob-file-list__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px 0 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
}

.ob-file {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: var(--ob-radius);
  background: var(--surface);
}

.ob-file__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 34px;
  height: 34px;
  border-radius: var(--ob-radius-sm);
  background: var(--info-muted);
  color: var(--info);
}

.ob-file__icon--pdf {
  background: var(--danger-muted);
  color: var(--danger);
}

.ob-file__meta {
  flex: 1 1;
  min-width: 0;
}

.ob-file__name {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--text-primary);
}

.ob-file__sub {
  margin: 0;
  font-size: 12px;
  color: var(--text-muted);
}

.ob-file__remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: var(--ob-radius-sm);
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  transition: background-color var(--ob-dur) var(--ob-ease), color var(--ob-dur) var(--ob-ease);
}

.ob-file__remove:hover:not(:disabled) {
  background: var(--danger-muted);
  color: var(--danger);
}

.ob-file__remove:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus);
}

/* Linked/summary tile */
.ob-tile {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--ob-surface-sunken);
}

.ob-tile__body {
  flex: 1 1;
  min-width: 0;
}

.ob-tile__title {
  margin: 0;
  font-size: 14px;
  font-weight: 650;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ob-tile__sub {
  margin: 2px 0 0;
  font-size: 12.5px;
  color: var(--text-muted);
}

/* Progress */
.ob-progress {
  width: 100%;
  height: 6px;
  border-radius: 999px;
  background: var(--border-subtle);
  overflow: hidden;
}

.ob-progress__fill {
  height: 100%;
  border-radius: inherit;
  background: var(--primary);
  transition: width 250ms var(--ob-ease);
}

.ob-progress-meta {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;
  font-size: 12.5px;
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

.ob-status-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 200px;
  margin: 16px 0 0;
  padding: 12px;
  overflow-y: auto;
  list-style: none;
  border: 1px solid var(--border);
  border-radius: var(--ob-radius);
  background: var(--ob-surface-sunken);
  text-align: left;
}

.ob-status-list li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 12.5px;
  line-height: 1.45;
  color: var(--text-secondary);
}

.ob-status-list li svg {
  flex: none;
  margin-top: 2px;
  color: var(--success);
}

/* --------------------------------------------------------------------------
   Modal
   -------------------------------------------------------------------------- */
.ob-modal-root {
  position: fixed;
  inset: 0;
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(2, 6, 23, 0.74);
  animation: ob-fade 160ms var(--ob-ease) both;
}

html:not([data-theme='dark']) .ob-modal-root {
  background: rgba(15, 23, 42, 0.5);
}

.ob-modal {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 520px;
  max-height: calc(100vh - 32px);
  max-height: calc(100dvh - 32px);
  border: 1px solid var(--border);
  border-radius: var(--ob-radius-xl);
  background: var(--modal-background);
  color: var(--text-primary);
  box-shadow: var(--modal-shadow);
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
  animation: ob-pop 180ms var(--ob-ease) both;
  outline: none;
}

.ob-modal--sm { max-width: 440px; }
.ob-modal--lg { max-width: 640px; }

.ob-modal__header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 24px 56px 0 24px;
}

.ob-modal__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 40px;
  height: 40px;
  border-radius: var(--ob-radius);
  background: var(--primary-muted);
  color: var(--primary);
}

.ob-modal__icon--warning { background: var(--warning-muted); color: var(--warning); }
.ob-modal__icon--danger { background: var(--danger-muted); color: var(--danger); }
.ob-modal__icon--success { background: var(--success-muted); color: var(--success); }
.ob-modal__icon--info { background: var(--info-muted); color: var(--info); }

.ob-modal__heading {
  min-width: 0;
}

.ob-modal__title {
  margin: 0;
  font-size: 18px;
  font-weight: 650;
  line-height: 1.35;
  color: var(--text-primary);
}

.ob-modal__desc {
  margin: 4px 0 0;
  font-size: 14px;
  line-height: 1.55;
  color: var(--text-secondary);
}

.ob-modal__close {
  position: absolute;
  top: 14px;
  right: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: var(--ob-radius-sm);
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
}

.ob-modal__close:hover {
  background: var(--surface-hover);
  color: var(--text-primary);
}

.ob-modal__close:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus);
}

.ob-modal__body {
  padding: 16px 24px 0;
  overflow-y: auto;
  color: var(--text-secondary);
  font-size: 14px;
}

.ob-modal__body:empty {
  display: none;
}

.ob-modal__body p {
  margin: 0 0 12px;
}

.ob-modal__body p:last-child {
  margin-bottom: 0;
}

.ob-modal__footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 24px;
}

.ob-modal--center .ob-modal__header {
  flex-direction: column;
  align-items: center;
  padding: 32px 24px 0;
  text-align: center;
}

.ob-modal--center .ob-modal__body {
  text-align: center;
}

.ob-modal--center .ob-modal__footer {
  justify-content: center;
}

.ob-kv {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 8px 16px;
  margin: 0;
  padding: 12px 14px;
  border: 1px solid var(--border);
  border-radius: var(--ob-radius);
  background: var(--ob-surface-sunken);
  font-size: 13.5px;
}

.ob-kv dt {
  color: var(--text-muted);
}

.ob-kv dd {
  margin: 0;
  color: var(--text-primary);
  font-weight: 600;
  text-align: right;
}

/* Legacy in-step modals (wizard-modal-overlay / modal-overlay inside the wizard) */
.wizard-layout .wizard-modal-overlay,
.wizard-modal-overlay {
  background: rgba(2, 6, 23, 0.74) !important;
  backdrop-filter: none !important;
}

html:not([data-theme='dark']) .wizard-modal-overlay {
  background: rgba(15, 23, 42, 0.5) !important;
}

.wizard-modal-overlay .wizard-modal {
  border: 1px solid var(--border) !important;
  border-radius: var(--ob-radius-xl, 16px) !important;
  background: var(--modal-background) !important;
  color: var(--text-primary) !important;
  box-shadow: var(--modal-shadow) !important;
}

.wizard-modal-overlay .wizard-modal h2,
.wizard-modal-overlay .wizard-modal h3,
.wizard-modal-overlay .wizard-modal h4 {
  color: var(--text-primary) !important;
}

/* --------------------------------------------------------------------------
   Existing per-step building blocks (mode cards, path cards, badges…)
   -------------------------------------------------------------------------- */
.wizard-layout .wizard-mode-card,
.wizard-layout .wizard-path-card,
.wizard-layout .path-card,
.wizard-layout .wizard-option-card {
  border: 1px solid var(--border);
  border-radius: var(--ob-radius-lg);
  background: var(--surface);
  color: var(--text-primary);
  box-shadow: none;
  transform: none;
  transition: border-color var(--ob-dur) var(--ob-ease), background-color var(--ob-dur) var(--ob-ease),
    box-shadow var(--ob-dur) var(--ob-ease);
}

.wizard-layout .wizard-mode-card:hover,
.wizard-layout .wizard-path-card:hover,
.wizard-layout .path-card:hover,
.wizard-layout .wizard-option-card:hover {
  border-color: var(--border-strong);
  background: var(--surface-hover);
  transform: none;
  box-shadow: none;
}

.wizard-layout .wizard-mode-card.selected,
.wizard-layout .wizard-path-card.selected,
.wizard-layout .path-card.selected,
.wizard-layout .wizard-option-card.selected {
  border-color: var(--primary);
  background: var(--primary-subtle);
  box-shadow: inset 0 0 0 1px var(--primary);
}

.wizard-layout .wizard-recommended-badge {
  position: absolute;
  top: 16px;
  right: 16px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--success-muted);
  color: var(--success);
  font-size: 11.5px;
  font-weight: 600;
  box-shadow: none;
}

.wizard-layout .wizard-progress-bar {
  margin-bottom: 8px;
  height: 6px;
  border-radius: 999px;
  background: var(--border-subtle);
  overflow: hidden;
}

.wizard-layout .wizard-progress-fill {
  height: 100%;
  border-radius: inherit;
  background: var(--primary);
}

.wizard-layout .wizard-progress-text {
  font-size: 12.5px;
  color: var(--text-muted);
}

.wizard-layout .wizard-logs {
  border: 1px solid var(--border);
  border-radius: var(--ob-radius);
  background: var(--ob-surface-sunken);
  color: var(--text-secondary);
}

.wizard-layout .wizard-form-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-primary);
}

.wizard-layout .wizard-form-checkbox input {
  accent-color: var(--primary);
}

/* --------------------------------------------------------------------------
   Dark theme: neutralise legacy hard-coded light surfaces/text in later steps.
   (Inline styles are serialised as rgb() by the browser.)
   -------------------------------------------------------------------------- */
html[data-theme='dark'] .wizard-layout :is(
  [style*='background-color: white'],
  [style*='background: white'],
  [style*='background-color: rgb(255, 255, 255)'],
  [style*='background: rgb(255, 255, 255)'],
  [style*='background-color: rgb(248, 249, 250)'],
  [style*='background: rgb(248, 249, 250)'],
  [style*='background-color: rgb(250, 250, 250)'],
  [style*='background: rgb(250, 250, 250)'],
  [style*='background-color: rgb(249, 250, 251)'],
  [style*='background: rgb(249, 250, 251)'],
  [style*='background-color: rgb(248, 250, 252)'],
  [style*='background: rgb(248, 250, 252)'],
  [style*='background-color: rgb(247, 247, 251)'],
  [style*='background: rgb(247, 247, 251)']
),
html[data-theme='dark'] .wizard-modal-overlay :is(
  [style*='background-color: white'],
  [style*='background: white'],
  [style*='background-color: rgb(255, 255, 255)'],
  [style*='background: rgb(255, 255, 255)'],
  [style*='background-color: rgb(248, 249, 250)'],
  [style*='background: rgb(248, 249, 250)']
) {
  background: var(--surface-raised) !important;
}

html[data-theme='dark'] .wizard-layout :is(
  [style*='background-color: rgb(240, 247, 255)'],
  [style*='background: rgb(240, 247, 255)'],
  [style*='background-color: rgb(239, 246, 255)'],
  [style*='background: rgb(239, 246, 255)'],
  [style*='background-color: rgb(232, 244, 253)'],
  [style*='background: rgb(232, 244, 253)'],
  [style*='background-color: rgb(227, 242, 253)'],
  [style*='background: rgb(227, 242, 253)']
) {
  background: var(--info-muted) !important;
}

html[data-theme='dark'] .wizard-layout :is(
  [style*='background-color: rgb(212, 237, 218)'],
  [style*='background: rgb(212, 237, 218)'],
  [style*='background-color: rgb(240, 253, 244)'],
  [style*='background: rgb(240, 253, 244)'],
  [style*='background-color: rgb(236, 253, 245)'],
  [style*='background: rgb(236, 253, 245)']
) {
  background: var(--success-muted) !important;
}

html[data-theme='dark'] .wizard-layout :is(
  [style*='background-color: rgb(255, 243, 205)'],
  [style*='background: rgb(255, 243, 205)'],
  [style*='background-color: rgb(255, 251, 235)'],
  [style*='background: rgb(255, 251, 235)']
) {
  background: var(--warning-muted) !important;
}

html[data-theme='dark'] .wizard-layout :is(
  [style*='background-color: rgb(233, 236, 239)'],
  [style*='background: rgb(233, 236, 239)'],
  [style*='background-color: rgb(241, 243, 245)'],
  [style*='background: rgb(241, 243, 245)'],
  [style*='background-color: rgb(243, 244, 246)'],
  [style*='background: rgb(243, 244, 246)']
) {
  background: var(--bg-tertiary) !important;
}

html[data-theme='dark'] :is(.wizard-layout, .wizard-modal-overlay) :is(
  [style*='color: rgb(33, 37, 41)'],
  [style*='color: rgb(51, 51, 51)'],
  [style*='color: rgb(17, 24, 39)'],
  [style*='color: rgb(31, 41, 55)'],
  [style*='color: rgb(15, 23, 42)'],
  [style*='color: rgb(0, 0, 0)'],
  [style*='color: black']
):not(button) {
  color: var(--text-primary) !important;
}

html[data-theme='dark'] :is(.wizard-layout, .wizard-modal-overlay) :is(
  [style*='color: rgb(73, 80, 87)'],
  [style*='color: rgb(102, 102, 102)'],
  [style*='color: rgb(68, 68, 68)'],
  [style*='color: rgb(85, 85, 85)'],
  [style*='color: rgb(108, 117, 125)'],
  [style*='color: rgb(75, 85, 99)'],
  [style*='color: rgb(107, 114, 128)'],
  [style*='color: rgb(173, 181, 189)']
):not(button) {
  color: var(--text-secondary) !important;
}

html[data-theme='dark'] .wizard-layout :is(
  [style*='border: 1px solid rgb(222, 226, 230)'],
  [style*='border: 1px solid rgb(229, 231, 235)'],
  [style*='border: 1px solid rgb(204, 204, 204)'],
  [style*='border: 1px solid rgb(221, 221, 221)'],
  [style*='border: 1px solid rgb(233, 236, 239)']
) {
  border-color: var(--border) !important;
}

/* Tailwind utility leftovers inside the wizard */
html[data-theme='dark'] .wizard-layout .bg-white { background-color: var(--surface-raised) !important; }
html[data-theme='dark'] .wizard-layout :is(.bg-gray-50, .bg-gray-100, .bg-slate-50) { background-color: var(--bg-tertiary) !important; }
html[data-theme='dark'] .wizard-layout :is(.bg-blue-50, .bg-indigo-50) { background-color: var(--info-muted) !important; }
html[data-theme='dark'] .wizard-layout .bg-green-50 { background-color: var(--success-muted) !important; }
html[data-theme='dark'] .wizard-layout :is(.bg-orange-50, .bg-yellow-50, .bg-amber-50) { background-color: var(--warning-muted) !important; }
html[data-theme='dark'] .wizard-layout .bg-red-50 { background-color: var(--danger-muted) !important; }
html[data-theme='dark'] .wizard-layout :is(.bg-blue-200, .bg-indigo-200, .bg-orange-200, .bg-gray-200) { background-color: var(--border) !important; }
html[data-theme='dark'] .wizard-layout :is(.text-gray-900, .text-gray-800, .text-slate-900, .text-black) { color: var(--text-primary) !important; }
html[data-theme='dark'] .wizard-layout :is(.text-gray-700, .text-gray-600, .text-slate-600) { color: var(--text-secondary) !important; }
html[data-theme='dark'] .wizard-layout :is(.text-gray-500, .text-gray-400) { color: var(--text-muted) !important; }
html[data-theme='dark'] .wizard-layout :is(.border-gray-200, .border-gray-300, .border-slate-200) { border-color: var(--border) !important; }

/* --------------------------------------------------------------------------
   Motion
   -------------------------------------------------------------------------- */
@keyframes ob-enter {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: none; }
}

@keyframes ob-pop {
  from { opacity: 0; transform: translateY(4px) scale(0.985); }
  to { opacity: 1; transform: none; }
}

@keyframes ob-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes ob-spin {
  to { transform: rotate(360deg); }
}

@media (prefers-reduced-motion: reduce) {
  .wizard-layout *,
  .wizard-layout *::before,
  .wizard-layout *::after,
  .ob-modal-root,
  .ob-modal-root * {
    animation-duration: 1ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 1ms !important;
    scroll-behavior: auto !important;
  }

  .ob-spinner,
  .wizard-layout .spinner-small {
    animation: ob-spin 1.4s linear infinite !important;
  }
}

/* --------------------------------------------------------------------------
   Responsive
   -------------------------------------------------------------------------- */
@media (max-width: 900px) {
  .ob-choice-grid--3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 720px) {
  .wizard-layout,
  .ob-modal-root {
    --ob-pad-x: 20px;
    --ob-header-h: 56px;
  }

  .wizard-layout .wizard-main {
    padding: 0 12px;
  }

  .wizard-layout .wizard-header-content {
    padding: 0 16px;
  }

  .wizard-layout .ob-header-tag {
    display: none;
  }

  .wizard-layout .wizard-card-header {
    padding-top: 22px;
  }

  .wizard-layout .wizard-card-title {
    font-size: 22px;
  }

  .wizard-layout .wizard-card-subtitle {
    font-size: 14px;
  }

  .wizard-layout .wizard-form-row,
  .wizard-layout .wizard-workspace-form,
  .ob-grid-2,
  .ob-choice-grid--2,
  .ob-choice-grid--3 {
    grid-template-columns: minmax(0, 1fr);
  }

  .wizard-layout .wizard-card-content > .wizard-actions,
  .wizard-layout .wizard-card-content > .wizard-workspace-actions,
  .wizard-layout .wizard-card-content > .wizard-project-actions,
  .wizard-layout .wizard-card-content > .ob-actions {
    padding: 12px var(--ob-pad-x);
  }

  .ob-stepper {
    padding-top: 12px;
  }

  .ob-stepper__percent {
    display: none;
  }

  .ob-modal__footer {
    flex-direction: column-reverse;
    align-items: stretch;
  }

  .ob-modal__footer .ob-btn {
    width: 100%;
  }
}

/* --------------------------------------------------------------------------
   Step 1 hero
   -------------------------------------------------------------------------- */
.ob-hero {
  max-width: 760px;
  margin: 0 auto;
  padding: 40px 0 28px;
  text-align: center;
  animation: ob-enter 220ms var(--ob-ease) both;
}

.ob-hero__eyebrow {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--primary);
}

.ob-hero__title {
  margin: 0;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--text-primary);
}

.ob-hero__subtitle {
  margin: 10px auto 0;
  max-width: 620px;
  font-size: 15px;
  line-height: 1.6;
  color: var(--text-secondary);
}

.ob-hero__journey {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin: 20px 0 0;
  padding: 0;
  list-style: none;
}

.ob-hero__journey li {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 30px;
  padding: 0 12px 0 4px;
  border: 1px solid var(--border);
  border-radius: 999px;
  background: var(--surface);
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
}

.ob-hero__journey li span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--bg-tertiary);
  font-size: 11.5px;
  font-weight: 600;
  color: var(--text-muted);
}

.ob-hero__journey li.is-active {
  border-color: color-mix(in srgb, var(--primary) 35%, transparent);
  color: var(--text-primary);
}

.ob-hero__journey li.is-active span {
  background: var(--primary);
  color: var(--ob-on-primary);
}

.wizard-layout.public .wizard-container {
  max-width: 960px;
}

@media (max-width: 720px) {
  .ob-hero {
    padding: 24px 0 20px;
  }

  .ob-hero__title {
    font-size: 24px;
  }
}

/* --------------------------------------------------------------------------
   Step 4 section rhythm + project key field (wizard-scoped)
   -------------------------------------------------------------------------- */
.wizard-layout .wizard-path-content {
  margin-top: 0;
}

.wizard-layout .ob-section + .wizard-path-content:not(.ob-section) > .ob-section:first-child,
.wizard-layout .wizard-path-content > .ob-choice-grid + .ob-section {
  margin-top: 28px;
  padding-top: 28px;
  border-top: 1px solid var(--border);
}

.ob-modal__header:last-child {
  padding-bottom: 32px;
}

.wizard-layout .ob-project-key > .wizard-form-group {
  margin: 0 !important;
}

.wizard-layout .ob-project-key .wizard-form-label {
  font-size: 15px;
  font-weight: 650;
}

.wizard-layout .ob-project-key code {
  background: var(--bg-tertiary) !important;
  color: var(--text-primary);
  border: 1px solid var(--border);
}

.wizard-layout .ob-project-key .font-mono {
  height: 26px;
  padding: 0 10px !important;
  border-radius: 999px !important;
  font-size: 12px;
}

.wizard-layout .ob-project-key .font-mono:not(.bg-blue-600) {
  background: var(--surface) !important;
  border-color: var(--border) !important;
  color: var(--text-secondary) !important;
}

.wizard-layout .ob-project-key .font-mono:not(.bg-blue-600):hover {
  border-color: var(--primary) !important;
  color: var(--text-primary) !important;
}

.wizard-layout .ob-project-key .font-mono.bg-blue-600 {
  background: var(--primary) !important;
  border-color: var(--primary) !important;
}

.wizard-layout .ob-project-key .shrink-0.rounded-md {
  height: var(--ob-field-h) !important;
  padding: 0 18px !important;
  border-radius: var(--ob-radius) !important;
  font-weight: 600 !important;
}

.wizard-layout .ob-project-key .shrink-0.rounded-md.bg-blue-600 {
  background: var(--primary) !important;
}

.wizard-layout .ob-project-key .shrink-0.rounded-md.bg-gray-100 {
  background: var(--surface-disabled) !important;
  color: var(--text-muted) !important;
  border: 1px solid var(--border);
}

.wizard-layout .ob-project-key .text-gray-500 {
  color: var(--text-muted) !important;
}

/* --------------------------------------------------------------------------
   Legacy variable aliases used by later steps' inline styles
   (previously undefined → rendered transparent / inherited).
   -------------------------------------------------------------------------- */
.wizard-layout,
.wizard-modal-overlay,
.ob-modal-root {
  --card-bg: var(--surface);
  --background-color: var(--bg-primary);
  --success-bg: var(--success-muted);
  --success-color-light: var(--success-muted);
  --info-color-light: var(--info-muted);
  --warning-color-light: var(--warning-muted);
  --primary-color-light: var(--primary-muted);
  --error-color: var(--danger);
  --error-color-light: var(--danger-muted);
}

/* Replace saturated legacy gradients with flat token colours */
.wizard-layout :is(
  [style*='linear-gradient(135deg, rgb(102, 126, 234)'],
  [style*='linear-gradient(90deg, rgb(102, 126, 234)'],
  [style*='linear-gradient(135deg, rgb(79, 172, 254)']
),
.wizard-modal-overlay [style*='rgb(102, 126, 234)'] {
  background: var(--primary) !important;
}

.wizard-layout [style*='linear-gradient(135deg, rgb(240, 147, 251)'] {
  background: var(--danger) !important;
}

.wizard-layout [style*='linear-gradient(135deg, rgba(76, 201, 240, 0.1)'] {
  background: var(--info-muted) !important;
}

/* --------------------------------------------------------------------------
   Summary
   -------------------------------------------------------------------------- */
.ob-summary-hero {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding: 16px;
  border: 1px solid color-mix(in srgb, var(--success) 30%, transparent);
  border-radius: var(--ob-radius-lg);
  background: color-mix(in srgb, var(--success) 8%, var(--surface));
}

.ob-summary-hero__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: var(--success-muted);
  color: var(--success);
}

.ob-summary-hero__title {
  margin: 0;
  font-size: 16px;
  font-weight: 650;
  color: var(--text-primary);
}

.ob-summary-hero__sub {
  margin: 2px 0 0;
  font-size: 13.5px;
  color: var(--text-secondary);
}

.ob-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.ob-metric {
  --ob-metric-color: var(--primary);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 20px;
  border: 1px solid var(--border);
  border-radius: var(--ob-radius-lg);
  background: var(--surface);
}

.ob-metric--success { --ob-metric-color: var(--success); }
.ob-metric--warning { --ob-metric-color: var(--warning); }

.ob-metric__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: var(--ob-radius-sm);
  background: color-mix(in srgb, var(--ob-metric-color) 14%, transparent);
  color: var(--ob-metric-color);
}

.ob-metric__value {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: -0.02em;
  color: var(--text-primary);
  font-variant-numeric: tabular-nums;
}

.ob-metric__label {
  font-size: 13px;
  color: var(--text-muted);
}

.ob-skeleton {
  display: block;
  border-radius: 6px;
  background: var(--bg-tertiary);
  animation: ob-pulse 1.4s ease-in-out infinite;
}

@keyframes ob-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.45; }
}

@media (max-width: 720px) {
  .ob-metrics {
    grid-template-columns: minmax(0, 1fr);
  }
}

.wizard-layout.public .wizard-footer,
.wizard-layout.private .wizard-footer {
  background: transparent;
}

.ob-select__option.is-placeholder {
  font-weight: 500;
}

@media (max-width: 720px) {
  .wizard-layout .wizard-card-content > :is(.wizard-actions, .wizard-workspace-actions, .wizard-project-actions, .ob-actions) {
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 8px;
    margin-top: 24px;
  }

  .wizard-layout .wizard-card-content > :is(.wizard-actions, .wizard-workspace-actions, .wizard-project-actions, .ob-actions) > button,
  .wizard-layout .wizard-card-content > .wizard-project-actions > div > button {
    flex: 1 1;
    width: auto;
    min-width: 0;
    margin: 0;
    padding: 0 12px;
  }

  .wizard-layout .wizard-card-content > .wizard-project-actions > div {
    flex: 2 1;
    flex-wrap: nowrap !important;
    gap: 8px !important;
  }

  .wizard-layout .wizard-card-content > :is(.wizard-actions, .wizard-workspace-actions, .wizard-project-actions, .ob-actions) > .back,
  .wizard-layout .wizard-card-content > .wizard-actions > .wizard-btn-secondary:first-child,
  .wizard-layout .wizard-card-content > .ob-actions > .ob-actions__start {
    flex: 0 0 auto;
    margin-right: 0;
  }
}

/* ── Auth gate (/get-started/auth) ────────────────────────────────── */
.ob-authgate {
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
  gap: 20px;
  align-items: start;
  max-width: 1000px;
  margin: 8px auto 32px;
  animation: ob-enter 280ms var(--ease-out, ease);
}

.ob-authgate__aside {
  position: sticky;
  top: 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 26px;
  border-radius: 16px;
  border: 1px solid var(--border);
  background:
    radial-gradient(120% 80% at 0% 0%, var(--primary-subtle), transparent 60%),
    var(--surface);
}

.ob-authgate__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: fit-content;
  height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 600;
  color: var(--success);
  background: var(--success-muted);
}

.ob-authgate__aside-title {
  margin: 0;
  font-size: 20px;
  font-weight: 650;
  letter-spacing: -0.02em;
  line-height: 1.25;
  color: var(--text-primary);
}

.ob-authgate__aside-desc {
  margin: 0;
  font-size: 13.5px;
  line-height: 1.55;
  color: var(--text-secondary);
}

.ob-authgate__next {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 6px 0 0;
  padding: 0;
  list-style: none;
}

.ob-authgate__next li {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  font-size: 13.5px;
  color: var(--text-secondary);
}

.ob-authgate__next li:not(:last-child)::after {
  content: '';
  position: absolute;
  left: 13px;
  top: 36px;
  height: 12px;
  width: 1px;
  background: var(--border-strong);
}

.ob-authgate__next-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  border-radius: 8px;
  color: var(--text-muted);
  background: var(--bg-tertiary);
  border: 1px solid var(--border-subtle);
}

.ob-authgate__next li.is-current {
  color: var(--text-primary);
  font-weight: 600;
}

.ob-authgate__next li.is-current .ob-authgate__next-icon {
  color: #fff;
  background: var(--primary);
  border-color: transparent;
  box-shadow: 0 0 0 4px var(--primary-muted);
}

.ob-authgate__saved {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 6px;
  padding: 12px 14px;
  border-radius: 10px;
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--text-secondary);
  background: var(--bg-tertiary);
  border: 1px solid var(--border-subtle);
}

.ob-authgate__saved svg {
  flex-shrink: 0;
  margin-top: 1px;
  color: var(--primary);
}

.ob-authgate__card {
  border-radius: 16px;
  border: 1px solid var(--border);
  background: var(--surface);
  box-shadow: var(--shadow-lg);
  overflow: hidden;
}

.ob-authgate__header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 24px 28px 18px;
}

.ob-authgate__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 11px;
  color: var(--primary);
  background: var(--primary-subtle);
  border: 1px solid var(--primary-muted);
}

.ob-authgate__title {
  margin: 0 0 2px;
  font-size: 20px;
  font-weight: 650;
  letter-spacing: -0.02em;
  color: var(--text-primary);
}

.ob-authgate__subtitle {
  margin: 0;
  font-size: 13px;
  color: var(--text-secondary);
}

.ob-authgate__tabs {
  display: flex;
  gap: 4px;
  margin: 0 28px;
  padding: 4px;
  border-radius: 10px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
}

.ob-authgate__tab {
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  height: 34px;
  border: none;
  border-radius: 7px;
  background: transparent;
  color: var(--text-secondary);
  font: inherit;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  transition: background var(--duration-fast, 120ms) ease, color var(--duration-fast, 120ms) ease,
    box-shadow var(--duration-fast, 120ms) ease;
}

.ob-authgate__tab:hover {
  color: var(--text-primary);
}

.ob-authgate__tab.is-active {
  color: var(--text-primary);
  background: var(--surface);
  box-shadow: var(--shadow-sm);
}

[data-theme='dark'] .ob-authgate__tab.is-active {
  background: var(--surface-selected);
}

.ob-authgate__tab:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus);
}

.ob-authgate__body {
  padding: 20px 28px 26px;
  animation: ob-auth-fade 220ms var(--ease-out, ease);
}

@keyframes ob-auth-fade {
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: none; }
}

/* Embedded Register / Login forms */
.ob-authgate__body form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.ob-authgate__body .form-group {
  margin: 0;
}

.ob-authgate__body .form-label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
}

.ob-authgate__body .form-input,
.ob-authgate__body input[type='email'],
.ob-authgate__body input[type='password'],
.ob-authgate__body input[type='text'],
.ob-authgate__body input[type='tel'] {
  width: 100%;
  height: 42px;
  padding: 0 12px;
  font-size: 14px;
  color: var(--text-primary) !important;
  background: var(--input-background) !important;
  border: 1px solid var(--input-border) !important;
  border-radius: 10px !important;
  box-shadow: none;
  transition: border-color var(--duration-fast, 120ms) ease, box-shadow var(--duration-fast, 120ms) ease;
}

.ob-authgate__body input::placeholder {
  color: var(--input-placeholder) !important;
}

.ob-authgate__body .form-input:hover,
.ob-authgate__body input:hover {
  border-color: var(--border-strong) !important;
}

.ob-authgate__body .form-input:focus,
.ob-authgate__body input:focus {
  outline: none;
  border-color: var(--primary) !important;
  box-shadow: var(--shadow-focus) !important;
}

.ob-authgate__body .form-input.error,
.ob-authgate__body input.error {
  border-color: var(--danger) !important;
}

.ob-authgate__body .relative > span,
.ob-authgate__body .relative > button,
.ob-authgate__body .password-toggle {
  color: var(--text-muted) !important;
}

.ob-authgate__body .form-error {
  margin-top: 5px;
  font-size: 12.5px;
  color: var(--danger);
}

.ob-authgate__body .remember-me-option {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 2px 0 0;
}

.ob-authgate__body .remember-me-checkbox {
  width: 16px;
  height: 16px;
  accent-color: var(--primary);
}

.ob-authgate__body .remember-me-label {
  font-size: 13px;
  color: var(--text-secondary);
  cursor: pointer;
}

.ob-authgate__body .btn-primary {
  height: 42px;
  margin-top: 4px;
  border: none !important;
  border-radius: 10px !important;
  background: var(--primary) !important;
  background-image: none !important;
  color: #fff !important;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.1) !important;
  transform: none !important;
  transition: background var(--duration-fast, 120ms) ease;
}

.ob-authgate__body .btn-primary:hover:not(:disabled) {
  background: var(--primary-hover) !important;
}

.ob-authgate__body .btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.ob-authgate__body .btn-link {
  padding: 0;
  border: none;
  background: none;
  color: var(--primary);
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
}

/* Login's email / phone switcher inside the gate */
.ob-authgate__body .auth-login-tabs {
  display: flex;
  gap: 18px;
  margin: 0 0 2px;
  border-bottom: 1px solid var(--border);
}

.ob-authgate__body .auth-login-tab {
  padding: 0 2px 9px;
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  background: transparent;
  color: var(--text-muted);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.ob-authgate__body .auth-login-tab.active {
  color: var(--text-primary);
  border-bottom-color: var(--primary);
}

/* Registration complete view */
.ob-authgate__body h3 {
  color: var(--text-primary);
  font-size: 17px;
  font-weight: 650;
}

.ob-authgate__body p[style*='color'] {
  color: var(--text-secondary) !important;
}

@media (max-width: 860px) {
  .ob-authgate {
    grid-template-columns: 1fr;
  }

  .ob-authgate__aside {
    position: static;
    order: 2;
  }

  .ob-authgate__next {
    display: none;
  }
}

@media (max-width: 520px) {
  .ob-authgate__header,
  .ob-authgate__body {
    padding-left: 18px;
    padding-right: 18px;
  }

  .ob-authgate__tabs {
    margin: 0 18px;
  }

  .ob-authgate__body form > div[style*='grid-template-columns'] {
    grid-template-columns: 1fr !important;
  }
}

@media (prefers-reduced-motion: reduce) {
  .ob-authgate,
  .ob-authgate__body {
    animation: none;
  }
}

.ob-authgate__body .remember-me-label,
.ob-authgate__body .remember-me-label span {
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  line-height: 1.45;
}

.ob-authgate__body .remember-me-option {
  align-items: flex-start;
}

.ob-authgate__body .remember-me-checkbox {
  flex-shrink: 0;
  margin-top: 2px;
}

/* Slate utilities (discovery ExecutionModeModal) */
html[data-theme='dark'] .wizard-layout :is(.text-slate-900, .text-slate-800, .text-slate-700) { color: var(--text-primary) !important; }
html[data-theme='dark'] .wizard-layout :is(.text-slate-600, .text-slate-500) { color: var(--text-secondary) !important; }
html[data-theme='dark'] .wizard-layout .text-slate-400 { color: var(--text-muted) !important; }
html[data-theme='dark'] .wizard-layout :is(.border-slate-100, .border-slate-300) { border-color: var(--border) !important; }
html[data-theme='dark'] .wizard-layout :is(.hover\\:bg-slate-100:hover, .hover\\:bg-slate-50:hover) { background-color: var(--surface-hover) !important; }
html[data-theme='dark'] .wizard-layout .hover\\:text-slate-600:hover { color: var(--text-primary) !important; }
`, "",{"version":3,"sources":["webpack://./src/styles/wizard-rt3.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;;AAE/E;;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA,oCAAoC,WAAW,EAAE;AACjD;EACE,kCAAkC;EAClC,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,UAAU;EACV,0BAA0B;EAC1B,UAAU;EACV,6BAA6B;EAC7B,sCAAsC;EACtC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,kCAAkC;EAClC,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB;6CAC2C;AAC7C;;AAEA;;;EAGE,gCAAgC;EAChC,kCAAkC;EAClC,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA;;+EAE+E;AAC/E;EACE,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,UAAU;EACV,gDAAgD;EAChD,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,qEAAqE;AACvE;;AAEA;EACE,QAAQ;EACR,oEAAoE;AACtE;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf;6CAC2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,iEAAiE;EACjE,gCAAgC;EAChC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,UAAU;EACV,+BAA+B;EAC/B,kCAAkC;EAClC,6BAA6B;EAC7B,4BAA4B;EAC5B,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,0BAA0B;EAC1B,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;;;;EAIE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,6CAA6C;EAC7C,6BAA6B;EAC7B,mCAAmC;EACnC,0DAA0D;EAC1D,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;+EAE+E;AAC/E;;;;;;EAME,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,+BAA+B;EAC/B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;qHACmH;AACrH;;AAEA;;;;;;EAME,aAAa;EACb,+BAA+B;AACjC;;AAEA;;;;;;EAME,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,YAAY;AACZ;;;;;;EAME,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;;;;;;EAME,gCAAgC;EAChC,kCAAkC;EAClC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA,cAAc;AACd;;;;;;;;;EASE,0BAA0B;EAC1B,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;;;;;;EAOE,gCAAgC;EAChC,kCAAkC;EAClC,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,uDAAuD;EACvD,yDAAyD;AAC3D;;AAEA;;;EAGE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;;EAEE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,0CAA0C;AAC1C;;EAEE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;;+EAE+E;AAC/E;;;EAGE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;;EAGE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;;EAGE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;;;;EAME,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,qCAAqC;EACrC,+BAA+B;EAC/B,mCAAmC;EACnC,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB;iDAC+C;AACjD;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;;;;;;EAME,aAAa;EACb,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;;;;;EAKE,mCAAmC;EACnC,4BAA4B;EAC5B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,qCAAqC;EACrC,+BAA+B;EAC/B,mCAAmC;EACnC,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8FAA8F;AAChG;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,iCAAiC;EACjC,4BAA4B;EAC5B,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,kCAAkC;EAClC,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,wBAAwB;AAC1B;;AAEA;;+EAE+E;AAC/E;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,+BAA+B;EAC/B,eAAe;EACf,wBAAwB;AAC1B;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,aAAa;EACb,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;EAC1B,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf;2CACyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,4BAA4B,gCAAgC,EAAE,qBAAqB,EAAE;AACrF,4BAA4B,gCAAgC,EAAE,qBAAqB,EAAE;AACrF,2BAA2B,+BAA+B,EAAE,oBAAoB,EAAE;AAClF,2BAA2B,+BAA+B,EAAE,oBAAoB,EAAE;;AAElF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,8BAA8B;EAC9B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,qBAAqB,gCAAgC,EAAE,qBAAqB,EAAE;AAC9E,qBAAqB,gCAAgC,EAAE,qBAAqB,EAAE;AAC9E,qBAAqB,gCAAgC,EAAE,qBAAqB,EAAE;AAC9E,kBAAkB,6BAA6B,EAAE,kBAAkB,EAAE;;AAErE;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yFAAyF;EACzF,mBAAmB;EACnB,qFAAqF;EACrF,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kBAAkB,6BAA6B,EAAE;AACjD,qBAAqB,gCAAgC,EAAE;AACvD,qBAAqB,gCAAgC,EAAE;AACvD,oBAAoB,+BAA+B,EAAE;AACrD,qBAAqB,mCAAmC,EAAE;;AAE1D;EACE,UAAU;EACV,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;+EAE+E;AAC/E;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,kCAAkC;EAClC,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,oGAAoG;AACtG;;AAEA;;EAEE,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kCAAkC;EAClC,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,6FAA6F;AAC/F;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,aAAa;AACb;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,qBAAqB;AACvB;;AAEA;;+EAE+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;EAC1B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,aAAa;AACf;;AAEA,gBAAgB,gBAAgB,EAAE;AAClC,gBAAgB,gBAAgB,EAAE;;AAElC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA,2BAA2B,gCAAgC,EAAE,qBAAqB,EAAE;AACpF,0BAA0B,+BAA+B,EAAE,oBAAoB,EAAE;AACjF,2BAA2B,gCAAgC,EAAE,qBAAqB,EAAE;AACpF,wBAAwB,6BAA6B,EAAE,kBAAkB,EAAE;;AAE3E;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kCAAkC;EAClC,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,mFAAmF;AACnF;;EAEE,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;EAC1C,mDAAmD;EACnD,8CAA8C;EAC9C,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;;+EAE+E;AAC/E;;;;EAIE,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf;2CACyC;AAC3C;;AAEA;;;;EAIE,kCAAkC;EAClC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,4BAA4B;EAC5B,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,gCAAgC;EAChC,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;+EAG+E;AAC/E;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,4CAA4C;AAC9C;;AAEA;;;;;;;;;;EAUE,wCAAwC;AAC1C;;AAEA;;;;;;;;EAQE,2CAA2C;AAC7C;;AAEA;;;;;;EAME,2CAA2C;AAC7C;;AAEA;;;;;;;;EAQE,yCAAyC;AAC3C;;AAEA;;;;;;;;;EASE,qCAAqC;AACvC;;AAEA;;;;;;;;;;EAUE,uCAAuC;AACzC;;AAEA;;;;;;;EAOE,sCAAsC;AACxC;;AAEA,iDAAiD;AACjD,mDAAmD,kDAAkD,EAAE;AACvG,sFAAsF,+CAA+C,EAAE;AACvI,yEAAyE,8CAA8C,EAAE;AACzH,sDAAsD,iDAAiD,EAAE;AACzG,yFAAyF,iDAAiD,EAAE;AAC5I,oDAAoD,gDAAgD,EAAE;AACtG,yGAAyG,0CAA0C,EAAE;AACrJ,2GAA2G,qCAAqC,EAAE;AAClJ,8FAA8F,uCAAuC,EAAE;AACvI,6EAA6E,mCAAmC,EAAE;AAClH,oGAAoG,sCAAsC,EAAE;;AAE5I;;+EAE+E;AAC/E;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE;;;;;IAKE,kCAAkC;IAClC,uCAAuC;IACvC,mCAAmC;IACnC,gCAAgC;EAClC;;EAEA;;IAEE,kDAAkD;EACpD;AACF;;AAEA;;+EAE+E;AAC/E;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;;IAEE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;;IAKE,qCAAqC;EACvC;;EAEA;;;;IAIE,6BAA6B;EAC/B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;+EAE+E;AAC/E;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,qBAAqB;EACrB,+BAA+B;EAC/B,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,iEAAiE;EACjE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8CAA8C;EAC9C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;;+EAG+E;AAC/E;;;EAGE,yBAAyB;EACzB,qCAAqC;EACrC,kCAAkC;EAClC,2CAA2C;EAC3C,qCAAqC;EACrC,2CAA2C;EAC3C,2CAA2C;EAC3C,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA,+DAA+D;AAC/D;;;;;;EAME,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,qEAAqE;EACrE,kCAAkC;EAClC,iEAAiE;AACnE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA,sBAAsB,iCAAiC,EAAE;AACzD,sBAAsB,iCAAiC,EAAE;;AAEzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,uEAAuE;EACvE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,aAAa,EAAE;AACvB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;IACnB,iBAAiB;IACjB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;;IAEE,SAAW;IACX,WAAW;IACX,YAAY;IACZ,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,SAAW;IACX,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;;;IAGE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,wDAAwD;EACxD,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B;;kBAEgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf;+CAC6C;AAC/C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,mDAAmD;AACrD;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,qCAAqC;EACrC,8CAA8C;EAC9C,gDAAgD;EAChD,8BAA8B;EAC9B,gBAAgB;EAChB,sGAAsG;AACxG;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;;EAEE,aAAa;EACb,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;;EAGE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,qCAAqC;EACrC,iCAAiC;EACjC,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,+FAA+F;EAC/F,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA,+BAA+B;AAC/B;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,mDAAmD;AACnD,gGAAgG,qCAAqC,EAAE;AACvI,+EAA+E,uCAAuC,EAAE;AACxH,yDAAyD,mCAAmC,EAAE;AAC9F,mFAAmF,sCAAsC,EAAE;AAC3H,oGAAoG,iDAAiD,EAAE;AACvJ,sEAAsE,qCAAqC,EAAE","sourcesContent":["/* ==========================================================================\n   Robitest onboarding wizard — presentation layer (loaded after wizard.css).\n   Everything is token-driven so light/dark follow html[data-theme].\n   Spacing scale: 4 / 8 / 12 / 16 / 20 / 24 / 32 / 40 / 48\n   ========================================================================== */\n\n.wizard-layout,\n.ob-modal-root {\n  --ob-radius-sm: 8px;\n  --ob-radius: 10px;\n  --ob-radius-lg: 14px;\n  --ob-radius-xl: 16px;\n  --ob-header-h: 60px;\n  --ob-pad-x: 32px;\n  --ob-ease: cubic-bezier(0.2, 0, 0, 1);\n  --ob-dur: 180ms;\n  --ob-field-h: 42px;\n  --ob-surface: var(--surface);\n  --ob-surface-sunken: var(--bg-tertiary);\n  --ob-on-primary: #ffffff;\n}\n\n/* --------------------------------------------------------------------------\n   Layout: the wizard is its own scroll container (html/body are locked).\n   -------------------------------------------------------------------------- */\n.wizard-layout {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  height: 100dvh;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-size: 14px;\n  line-height: 1.5;\n  scrollbar-width: thin;\n  scrollbar-color: var(--scrollbar-thumb) transparent;\n}\n\n.wizard-layout::-webkit-scrollbar { width: 10px; }\n.wizard-layout::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb);\n  border-radius: 999px;\n  border: 3px solid var(--bg-primary);\n}\n\n.wizard-layout .wizard-header {\n  position: sticky;\n  top: 0;\n  z-index: 40;\n  flex: none;\n  height: var(--ob-header-h);\n  padding: 0;\n  background: var(--bg-primary);\n  border-bottom: 1px solid var(--border);\n  box-shadow: none;\n  backdrop-filter: none;\n}\n\n.wizard-layout .wizard-header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  width: 100%;\n  max-width: 1200px;\n  height: 100%;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.wizard-layout .wizard-logo {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.wizard-layout .wizard-logo img {\n  width: 28px;\n  height: 28px;\n  object-fit: contain;\n}\n\n.wizard-layout .wizard-logo-text {\n  font-size: 16px;\n  font-weight: 650;\n  letter-spacing: -0.01em;\n  color: var(--text-primary);\n  background: none;\n  -webkit-text-fill-color: currentColor;\n}\n\n.wizard-layout .ob-header-tag {\n  padding: 2px 8px;\n  border: 1px solid var(--border);\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-muted);\n}\n\n.wizard-layout .wizard-header-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.wizard-layout .wizard-exit-btn,\n.wizard-layout .wizard-save-exit-btn,\n.wizard-layout .wizard-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 34px;\n  padding: 0 12px;\n  border: 1px solid var(--border);\n  border-radius: var(--ob-radius-sm);\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1;\n  cursor: pointer;\n  box-shadow: none;\n  transition: background-color var(--ob-dur) var(--ob-ease), color var(--ob-dur) var(--ob-ease),\n    border-color var(--ob-dur) var(--ob-ease);\n}\n\n.wizard-layout .wizard-exit-btn:hover,\n.wizard-layout .wizard-save-exit-btn:hover,\n.wizard-layout .wizard-back-btn:hover {\n  background: var(--surface-hover);\n  border-color: var(--border-strong);\n  color: var(--text-primary);\n  transform: none;\n}\n\n.wizard-layout .wizard-main {\n  flex: 1 0 auto;\n  display: block;\n  max-height: none;\n  min-height: 0;\n  overflow: visible;\n  padding: 0 24px;\n  background: transparent;\n}\n\n.wizard-layout .wizard-container {\n  width: 100%;\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 0 0 40px;\n}\n\n.wizard-layout .wizard-footer {\n  flex: none;\n  padding: 16px 24px;\n  border-top: 1px solid var(--border-subtle);\n  background: transparent;\n  text-align: center;\n}\n\n.wizard-layout .wizard-footer p {\n  margin: 0;\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n/* --------------------------------------------------------------------------\n   Stepper\n   -------------------------------------------------------------------------- */\n.ob-stepper {\n  position: sticky;\n  top: var(--ob-header-h);\n  z-index: 30;\n  margin: 0 0 20px;\n  padding: 16px 0 12px;\n  background: var(--bg-primary);\n}\n\n.ob-stepper__summary {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.ob-stepper__count {\n  font-size: 13px;\n  color: var(--text-muted);\n  white-space: nowrap;\n}\n\n.ob-stepper__count strong {\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n.ob-stepper__percent {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n.ob-stepper__bar {\n  height: 3px;\n  margin-bottom: 12px;\n  border-radius: 999px;\n  background: var(--border-subtle);\n  overflow: hidden;\n}\n\n.ob-stepper__bar-fill {\n  height: 100%;\n  border-radius: inherit;\n  background: var(--primary);\n  transition: width 250ms var(--ob-ease);\n}\n\n.ob-stepper__viewport {\n  position: relative;\n}\n\n.ob-stepper__viewport::before,\n.ob-stepper__viewport::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 32px;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity var(--ob-dur) var(--ob-ease);\n  z-index: 1;\n}\n\n.ob-stepper__viewport::before {\n  left: 0;\n  background: linear-gradient(to right, var(--bg-primary), transparent);\n}\n\n.ob-stepper__viewport::after {\n  right: 0;\n  background: linear-gradient(to left, var(--bg-primary), transparent);\n}\n\n.ob-stepper__viewport.has-left::before,\n.ob-stepper__viewport.has-right::after {\n  opacity: 1;\n}\n\n.ob-stepper__track {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin: 0;\n  padding: 2px;\n  list-style: none;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scroll-behavior: smooth;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.ob-stepper__track::-webkit-scrollbar {\n  display: none;\n}\n\n.ob-stepper__item {\n  display: flex;\n  align-items: center;\n  flex: none;\n  gap: 4px;\n}\n\n.ob-step {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 34px;\n  padding: 0 12px 0 5px;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  background: transparent;\n  color: var(--text-muted);\n  font-size: 13px;\n  font-weight: 500;\n  white-space: nowrap;\n  cursor: default;\n  transition: background-color var(--ob-dur) var(--ob-ease), color var(--ob-dur) var(--ob-ease),\n    border-color var(--ob-dur) var(--ob-ease);\n}\n\n.ob-step__dot {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  width: 24px;\n  height: 24px;\n  border: 1.5px solid var(--border-strong);\n  border-radius: 50%;\n  background: var(--surface);\n  color: var(--text-muted);\n  font-size: 12px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n.ob-step.is-complete {\n  color: var(--text-secondary);\n}\n\n.ob-step.is-complete .ob-step__dot {\n  border-color: var(--primary);\n  background: var(--primary);\n  color: var(--ob-on-primary);\n}\n\n.ob-step.is-current {\n  border-color: color-mix(in srgb, var(--primary) 35%, transparent);\n  background: var(--primary-muted);\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n.ob-step.is-current .ob-step__dot {\n  border: 2px solid var(--primary);\n  background: var(--surface);\n  color: var(--primary);\n}\n\n.ob-step.is-clickable {\n  cursor: pointer;\n}\n\n.ob-step.is-clickable:hover {\n  background: var(--surface-hover);\n  color: var(--text-primary);\n}\n\n.ob-step:focus-visible {\n  outline: none;\n  box-shadow: var(--shadow-focus);\n}\n\n.ob-stepper__sep {\n  flex: none;\n  width: 16px;\n  height: 1.5px;\n  border-radius: 999px;\n  background: var(--border);\n}\n\n.ob-stepper__sep.is-complete {\n  background: var(--primary);\n}\n\n/* --------------------------------------------------------------------------\n   Step surface (one primary card per step)\n   -------------------------------------------------------------------------- */\n.wizard-layout .wizard-card {\n  position: relative;\n  max-width: none;\n  margin: 0;\n  padding: 0;\n  border: 1px solid var(--border);\n  border-radius: var(--ob-radius-xl);\n  background: var(--ob-surface);\n  box-shadow: var(--shadow-xs);\n  overflow: visible;\n  animation: ob-enter 220ms var(--ob-ease) both;\n}\n\n.wizard-layout .wizard-card-header {\n  margin: 0;\n  padding: 28px var(--ob-pad-x) 0;\n  border: 0;\n  background: none;\n  text-align: left;\n}\n\n.wizard-layout .wizard-card-title {\n  margin: 0;\n  font-size: 26px;\n  font-weight: 650;\n  line-height: 1.25;\n  letter-spacing: -0.015em;\n  color: var(--text-primary);\n  background: none;\n  -webkit-text-fill-color: currentColor;\n}\n\n.wizard-layout .wizard-card-subtitle {\n  max-width: 720px;\n  margin: 6px 0 0;\n  font-size: 15px;\n  line-height: 1.55;\n  color: var(--text-secondary);\n}\n\n.wizard-layout .wizard-card-content {\n  padding: 24px var(--ob-pad-x) 32px;\n  background: none;\n}\n\n/* Sticky action footer (bleeds to card edges) */\n.wizard-layout .wizard-card-content > .wizard-actions,\n.wizard-layout .wizard-card-content > .wizard-workspace-actions,\n.wizard-layout .wizard-card-content > .wizard-project-actions,\n.wizard-layout .wizard-card-content > .ob-actions {\n  position: sticky;\n  bottom: 0;\n  z-index: 20;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  margin: 32px calc(-1 * var(--ob-pad-x)) -32px;\n  padding: 16px var(--ob-pad-x);\n  border-top: 1px solid var(--border);\n  border-radius: 0 0 var(--ob-radius-xl) var(--ob-radius-xl);\n  background: var(--ob-surface);\n}\n\n.wizard-layout .wizard-actions,\n.wizard-layout .wizard-workspace-actions,\n.wizard-layout .wizard-project-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.wizard-layout .wizard-actions > .wizard-btn-secondary:first-child,\n.wizard-layout .wizard-workspace-actions > .back,\n.wizard-layout .wizard-project-actions > .back,\n.wizard-layout .ob-actions > .ob-actions__start {\n  margin-right: auto;\n}\n\n.wizard-layout .wizard-actions-next-only {\n  justify-content: flex-end;\n}\n\n/* --------------------------------------------------------------------------\n   Buttons\n   -------------------------------------------------------------------------- */\n.ob-btn,\n.wizard-layout .wizard-btn,\n.wizard-layout .wizard-workspace-actions > button,\n.wizard-layout .wizard-project-actions button,\n.wizard-layout .wizard-workspace-edit-btn,\n.wizard-layout .wizard-project-edit-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 40px;\n  min-width: 0;\n  padding: 0 18px;\n  border: 1px solid transparent;\n  border-radius: var(--ob-radius);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1;\n  white-space: nowrap;\n  text-decoration: none;\n  cursor: pointer;\n  box-shadow: none;\n  transform: none;\n  transition: background-color var(--ob-dur) var(--ob-ease), border-color var(--ob-dur) var(--ob-ease),\n    color var(--ob-dur) var(--ob-ease), box-shadow var(--ob-dur) var(--ob-ease), opacity var(--ob-dur) var(--ob-ease);\n}\n\n.ob-btn:focus-visible,\n.wizard-layout .wizard-btn:focus-visible,\n.wizard-layout .wizard-workspace-actions > button:focus-visible,\n.wizard-layout .wizard-project-actions button:focus-visible,\n.wizard-layout .wizard-workspace-edit-btn:focus-visible,\n.wizard-layout .wizard-project-edit-btn:focus-visible {\n  outline: none;\n  box-shadow: var(--shadow-focus);\n}\n\n.ob-btn:disabled,\n.wizard-layout .wizard-btn:disabled,\n.wizard-layout .wizard-workspace-actions > button:disabled,\n.wizard-layout .wizard-project-actions button:disabled,\n.wizard-layout .wizard-workspace-edit-btn:disabled,\n.wizard-layout .wizard-project-edit-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Primary */\n.ob-btn--primary,\n.wizard-layout .wizard-btn-primary,\n.wizard-layout .wizard-workspace-actions > .primary,\n.wizard-layout .wizard-project-actions .primary,\n.wizard-layout .wizard-workspace-edit-btn.primary,\n.wizard-layout .wizard-project-edit-btn.primary {\n  background: var(--primary);\n  border-color: var(--primary);\n  color: var(--ob-on-primary);\n}\n\n.ob-btn--primary:hover:not(:disabled),\n.wizard-layout .wizard-btn-primary:hover:not(:disabled),\n.wizard-layout .wizard-workspace-actions > .primary:hover:not(:disabled),\n.wizard-layout .wizard-project-actions .primary:hover:not(:disabled),\n.wizard-layout .wizard-workspace-edit-btn.primary:hover:not(:disabled),\n.wizard-layout .wizard-project-edit-btn.primary:hover:not(:disabled) {\n  background: var(--primary-hover);\n  border-color: var(--primary-hover);\n  color: var(--ob-on-primary);\n  transform: none;\n  box-shadow: none;\n}\n\n/* Secondary */\n.ob-btn--secondary,\n.wizard-layout .wizard-btn-secondary,\n.wizard-layout .wizard-workspace-actions > .back,\n.wizard-layout .wizard-project-actions .back,\n.wizard-layout .wizard-project-actions .secondary,\n.wizard-layout .wizard-workspace-edit-btn,\n.wizard-layout .wizard-project-edit-btn,\n.wizard-layout .wizard-workspace-edit-btn.secondary,\n.wizard-layout .wizard-project-edit-btn.secondary {\n  background: var(--surface);\n  border-color: var(--border-strong);\n  color: var(--text-primary);\n}\n\n.ob-btn--secondary:hover:not(:disabled),\n.wizard-layout .wizard-btn-secondary:hover:not(:disabled),\n.wizard-layout .wizard-workspace-actions > .back:hover:not(:disabled),\n.wizard-layout .wizard-project-actions .back:hover:not(:disabled),\n.wizard-layout .wizard-project-actions .secondary:hover:not(:disabled),\n.wizard-layout .wizard-workspace-edit-btn:not(.primary):hover:not(:disabled),\n.wizard-layout .wizard-project-edit-btn:not(.primary):hover:not(:disabled) {\n  background: var(--surface-hover);\n  border-color: var(--border-strong);\n  color: var(--text-primary);\n  transform: none;\n}\n\n/* Ghost / tertiary */\n.ob-btn--ghost {\n  background: transparent;\n  border-color: transparent;\n  color: var(--text-secondary);\n}\n\n.ob-btn--ghost:hover:not(:disabled) {\n  background: var(--surface-hover);\n  color: var(--text-primary);\n}\n\n/* Destructive */\n.ob-btn--danger {\n  background: var(--danger);\n  border-color: var(--danger);\n  color: #ffffff;\n}\n\n.ob-btn--danger:hover:not(:disabled) {\n  background: color-mix(in srgb, var(--danger) 88%, #000);\n  border-color: color-mix(in srgb, var(--danger) 88%, #000);\n}\n\n.ob-btn--sm,\n.wizard-layout .wizard-workspace-edit-btn,\n.wizard-layout .wizard-project-edit-btn {\n  height: 32px;\n  padding: 0 12px;\n  font-size: 13px;\n  border-radius: var(--ob-radius-sm);\n}\n\n.ob-btn--block {\n  width: 100%;\n}\n\n.ob-btn--icon {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n}\n\n.ob-spinner,\n.wizard-layout .spinner-small {\n  display: inline-block;\n  flex: none;\n  width: 14px;\n  height: 14px;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: ob-spin 0.7s linear infinite;\n}\n\n.ob-spinner--lg {\n  width: 28px;\n  height: 28px;\n  border-width: 3px;\n  color: var(--primary);\n}\n\n/* Inline edit headers (Step 2 / Step 3) */\n.wizard-layout .wizard-workspace-edit-header,\n.wizard-layout .wizard-project-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  margin: 0 0 16px;\n  padding: 0;\n  border: 0;\n  background: none;\n}\n\n.wizard-layout .wizard-workspace-edit-actions,\n.wizard-layout .wizard-project-edit-actions {\n  display: inline-flex;\n  gap: 8px;\n}\n\n/* --------------------------------------------------------------------------\n   Forms\n   -------------------------------------------------------------------------- */\n.wizard-layout .wizard-form-row,\n.wizard-layout .wizard-workspace-form,\n.ob-grid-2 {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 20px 24px;\n  margin: 0 0 20px;\n}\n\n.wizard-layout .wizard-form-row > .wizard-form-group,\n.wizard-layout .wizard-workspace-form > .wizard-workspace-form-group {\n  margin: 0;\n}\n\n.ob-col-span-2 {\n  grid-column: 1 / -1;\n}\n\n.wizard-layout .wizard-form-group,\n.wizard-layout .wizard-workspace-form-group,\n.ob-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n  margin: 0 0 20px;\n}\n\n.wizard-layout .wizard-form-label,\n.wizard-layout .wizard-workspace-form-group > label,\n.ob-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin: 0;\n  font-size: 13.5px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: var(--text-primary);\n}\n\n.wizard-layout .required,\n.ob-required {\n  color: var(--danger);\n  font-weight: 600;\n}\n\n.ob-optional {\n  font-weight: 500;\n  color: var(--text-muted);\n}\n\n.wizard-layout .wizard-form-help,\n.wizard-layout .wizard-workspace-form-group > p:not(.error),\n.ob-help {\n  margin: 0;\n  font-size: 12.5px;\n  line-height: 1.45;\n  color: var(--text-muted);\n}\n\n.wizard-layout .wizard-form-error,\n.wizard-layout .wizard-workspace-form-group > p.error,\n.ob-error {\n  margin: 0;\n  font-size: 12.5px;\n  line-height: 1.45;\n  color: var(--danger);\n}\n\n.wizard-layout .wizard-form-input,\n.wizard-layout .wizard-form-select,\n.wizard-layout .wizard-form-textarea,\n.wizard-layout .wizard-workspace-form-group > input,\n.wizard-layout .wizard-workspace-form-group > select,\n.ob-input {\n  width: 100%;\n  height: var(--ob-field-h);\n  padding: 0 12px;\n  border: 1px solid var(--input-border);\n  border-radius: var(--ob-radius);\n  background: var(--input-background);\n  color: var(--text-primary);\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.4;\n  box-shadow: none;\n  transition: border-color var(--ob-dur) var(--ob-ease), box-shadow var(--ob-dur) var(--ob-ease),\n    background-color var(--ob-dur) var(--ob-ease);\n}\n\n.wizard-layout .wizard-form-textarea,\n.wizard-layout textarea.ob-input {\n  height: auto;\n  min-height: 96px;\n  padding: 10px 12px;\n  resize: vertical;\n}\n\n.wizard-layout .wizard-form-input::placeholder,\n.wizard-layout .wizard-form-textarea::placeholder,\n.wizard-layout .wizard-workspace-form-group > input::placeholder,\n.ob-input::placeholder {\n  color: var(--input-placeholder);\n}\n\n.wizard-layout .wizard-form-input:hover:not(:disabled),\n.wizard-layout .wizard-form-select:hover:not(:disabled),\n.wizard-layout .wizard-workspace-form-group > input:hover:not(:disabled),\n.ob-input:hover:not(:disabled) {\n  border-color: var(--border-strong);\n}\n\n.wizard-layout .wizard-form-input:focus,\n.wizard-layout .wizard-form-select:focus,\n.wizard-layout .wizard-form-textarea:focus,\n.wizard-layout .wizard-workspace-form-group > input:focus,\n.wizard-layout .wizard-workspace-form-group > select:focus,\n.ob-input:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: var(--shadow-focus);\n}\n\n.wizard-layout .wizard-form-input.error,\n.wizard-layout .wizard-form-select.error,\n.ob-input.is-invalid {\n  border-color: var(--danger);\n}\n\n.wizard-layout .wizard-form-input:disabled,\n.wizard-layout .wizard-form-select:disabled,\n.wizard-layout .wizard-workspace-form-group > input:disabled,\n.wizard-layout .wizard-workspace-form-group > select:disabled,\n.ob-input:disabled {\n  background: var(--surface-disabled);\n  color: var(--text-secondary);\n  cursor: not-allowed;\n  opacity: 1;\n}\n\n.ob-input-group {\n  display: flex;\n  gap: 8px;\n  align-items: stretch;\n}\n\n.ob-input-group > .ob-input {\n  flex: 1;\n  min-width: 0;\n}\n\n.ob-input-group > .ob-btn {\n  height: var(--ob-field-h);\n  flex: none;\n}\n\n.ob-field-hint-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n/* --------------------------------------------------------------------------\n   Custom select (listbox)\n   -------------------------------------------------------------------------- */\n.ob-select {\n  position: relative;\n  width: 100%;\n  min-width: 0;\n}\n\n.ob-select__trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  height: var(--ob-field-h);\n  padding: 0 10px 0 12px;\n  border: 1px solid var(--input-border);\n  border-radius: var(--ob-radius);\n  background: var(--input-background);\n  color: var(--text-primary);\n  font-family: inherit;\n  font-size: 14px;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color var(--ob-dur) var(--ob-ease), box-shadow var(--ob-dur) var(--ob-ease);\n}\n\n.ob-select__trigger:hover:not(:disabled) {\n  border-color: var(--border-strong);\n}\n\n.ob-select__trigger:focus-visible,\n.ob-select.is-open .ob-select__trigger {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: var(--shadow-focus);\n}\n\n.ob-select__trigger:disabled {\n  background: var(--surface-disabled);\n  color: var(--text-secondary);\n  cursor: not-allowed;\n}\n\n.ob-select.is-invalid .ob-select__trigger {\n  border-color: var(--danger);\n}\n\n.ob-select__value {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ob-select__value.is-placeholder {\n  color: var(--input-placeholder);\n}\n\n.ob-select__chevron {\n  flex: none;\n  color: var(--text-muted);\n  transition: transform var(--ob-dur) var(--ob-ease);\n}\n\n.ob-select.is-open .ob-select__chevron {\n  transform: rotate(180deg);\n}\n\n.ob-select__menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  z-index: 60;\n  max-height: 280px;\n  margin: 0;\n  padding: 6px;\n  overflow-y: auto;\n  list-style: none;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  background: var(--surface-raised);\n  box-shadow: var(--shadow-lg);\n  animation: ob-pop 140ms var(--ob-ease) both;\n  scrollbar-width: thin;\n}\n\n.ob-select__menu.is-up {\n  top: auto;\n  bottom: calc(100% + 6px);\n}\n\n.ob-select__option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 9px 10px;\n  border-radius: var(--ob-radius-sm);\n  color: var(--text-primary);\n  font-size: 14px;\n  line-height: 1.35;\n  cursor: pointer;\n  user-select: none;\n}\n\n.ob-select__option.is-active {\n  background: var(--surface-hover);\n}\n\n.ob-select__option.is-selected {\n  color: var(--primary);\n  font-weight: 600;\n}\n\n.ob-select__option.is-placeholder {\n  color: var(--text-muted);\n}\n\n.ob-select__option[aria-disabled='true'] {\n  color: var(--text-muted);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.ob-select__option-hint {\n  font-size: 11.5px;\n  font-weight: 500;\n  color: var(--text-muted);\n}\n\n.ob-select__empty {\n  padding: 10px;\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n/* --------------------------------------------------------------------------\n   Sections / grouping inside the single step surface\n   -------------------------------------------------------------------------- */\n.ob-section + .ob-section {\n  margin-top: 28px;\n  padding-top: 28px;\n  border-top: 1px solid var(--border);\n}\n\n.ob-section__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.ob-section__title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 650;\n  line-height: 1.4;\n  color: var(--text-primary);\n}\n\n.ob-section__desc {\n  margin: 4px 0 0;\n  font-size: 13.5px;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n.ob-divider {\n  height: 1px;\n  margin: 24px 0;\n  border: 0;\n  background: var(--border);\n}\n\n.ob-muted {\n  color: var(--text-muted);\n}\n\n.ob-empty-hint {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: var(--ob-field-h);\n  margin-top: 26px;\n  padding: 0 12px;\n  border: 1px dashed var(--border);\n  border-radius: var(--ob-radius);\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n/* --------------------------------------------------------------------------\n   Selection cards (intent, source, tool, mode)\n   -------------------------------------------------------------------------- */\n.ob-choice-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 16px;\n}\n\n.ob-choice-grid--2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.ob-choice-grid--3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.ob-choice {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  width: 100%;\n  min-width: 0;\n  margin: 0;\n  padding: 20px;\n  border: 1px solid var(--border);\n  border-radius: var(--ob-radius-lg);\n  background: var(--surface);\n  color: var(--text-primary);\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color var(--ob-dur) var(--ob-ease), background-color var(--ob-dur) var(--ob-ease),\n    box-shadow var(--ob-dur) var(--ob-ease);\n}\n\n.ob-choice:hover:not(.is-disabled):not(:disabled) {\n  border-color: var(--border-strong);\n  background: var(--surface-hover);\n}\n\n.ob-choice:focus-visible {\n  outline: none;\n  box-shadow: var(--shadow-focus);\n}\n\n.ob-choice.is-selected {\n  border-color: var(--primary);\n  background: var(--primary-subtle);\n  box-shadow: inset 0 0 0 1px var(--primary);\n}\n\n.ob-choice.is-selected:hover:not(.is-disabled) {\n  border-color: var(--primary);\n  background: var(--primary-subtle);\n}\n\n.ob-choice.is-disabled,\n.ob-choice:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.ob-choice--compact {\n  flex-direction: row;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n}\n\n.ob-choice__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  width: 40px;\n  height: 40px;\n  border-radius: var(--ob-radius);\n  background: var(--primary-muted);\n  color: var(--primary);\n}\n\n.ob-choice__icon img {\n  width: 22px;\n  height: 22px;\n  object-fit: contain;\n}\n\n.ob-choice__icon--success { background: var(--success-muted); color: var(--success); }\n.ob-choice__icon--warning { background: var(--warning-muted); color: var(--warning); }\n.ob-choice__icon--accent { background: var(--accent-muted); color: var(--accent); }\n.ob-choice__icon--danger { background: var(--danger-muted); color: var(--danger); }\n\n.ob-choice__body {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.ob-choice__title {\n  margin: 0;\n  padding-right: 72px;\n  font-size: 15px;\n  font-weight: 650;\n  line-height: 1.35;\n  color: var(--text-primary);\n}\n\n.ob-choice--compact .ob-choice__title {\n  padding-right: 24px;\n  font-size: 14px;\n}\n\n.ob-choice__desc {\n  margin: 0;\n  font-size: 13.5px;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n.ob-choice__list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 8px 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.ob-choice__list li {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 13px;\n  line-height: 1.45;\n  color: var(--text-secondary);\n}\n\n.ob-choice__list li svg {\n  flex: none;\n  margin-top: 2px;\n  color: var(--success);\n}\n\n.ob-choice__list li.is-warning,\n.ob-choice__list li.is-warning svg {\n  color: var(--warning);\n}\n\n.ob-choice__badges {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  display: inline-flex;\n  gap: 6px;\n}\n\n.ob-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  font-size: 11.5px;\n  font-weight: 600;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.ob-badge--primary { background: var(--primary-muted); color: var(--primary); }\n.ob-badge--success { background: var(--success-muted); color: var(--success); }\n.ob-badge--warning { background: var(--warning-muted); color: var(--warning); }\n.ob-badge--info { background: var(--info-muted); color: var(--info); }\n\n.ob-choice__check {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: var(--primary);\n  color: var(--ob-on-primary);\n}\n\n.ob-choice__check + .ob-choice__badges {\n  right: 46px;\n}\n\n/* --------------------------------------------------------------------------\n   Alerts\n   -------------------------------------------------------------------------- */\n.ob-alert {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin: 0 0 20px;\n  padding: 12px 14px;\n  border: 1px solid color-mix(in srgb, var(--ob-alert-color, var(--info)) 30%, transparent);\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--ob-alert-color, var(--info)) 9%, var(--surface));\n  color: var(--text-primary);\n  font-size: 13.5px;\n  line-height: 1.5;\n}\n\n.ob-alert--info { --ob-alert-color: var(--info); }\n.ob-alert--success { --ob-alert-color: var(--success); }\n.ob-alert--warning { --ob-alert-color: var(--warning); }\n.ob-alert--danger { --ob-alert-color: var(--danger); }\n.ob-alert--neutral { --ob-alert-color: var(--text-muted); }\n\n.ob-alert__icon {\n  flex: none;\n  margin-top: 1px;\n  color: var(--ob-alert-color, var(--info));\n}\n\n.ob-alert__body {\n  flex: 1;\n  min-width: 0;\n  color: var(--text-secondary);\n}\n\n.ob-alert__title {\n  margin: 0 0 2px;\n  font-size: 13.5px;\n  font-weight: 650;\n  color: var(--text-primary);\n}\n\n.ob-alert__body p {\n  margin: 0;\n}\n\n.ob-alert__action {\n  flex: none;\n  align-self: center;\n}\n\n/* --------------------------------------------------------------------------\n   Disclosure (expandable help panel)\n   -------------------------------------------------------------------------- */\n.ob-disclosure {\n  margin-top: 24px;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  background: var(--ob-surface-sunken);\n}\n\n.ob-disclosure > summary {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  list-style: none;\n  font-size: 13.5px;\n  font-weight: 600;\n  color: var(--text-primary);\n  cursor: pointer;\n  user-select: none;\n  border-radius: 12px;\n}\n\n.ob-disclosure > summary::-webkit-details-marker {\n  display: none;\n}\n\n.ob-disclosure > summary:focus-visible {\n  outline: none;\n  box-shadow: var(--shadow-focus);\n}\n\n.ob-disclosure__icon {\n  flex: none;\n  color: var(--primary);\n}\n\n.ob-disclosure__chevron {\n  margin-left: auto;\n  color: var(--text-muted);\n  transition: transform var(--ob-dur) var(--ob-ease);\n}\n\n.ob-disclosure[open] .ob-disclosure__chevron {\n  transform: rotate(180deg);\n}\n\n.ob-disclosure__content {\n  padding: 0 14px 14px 40px;\n  font-size: 13.5px;\n  line-height: 1.6;\n  color: var(--text-secondary);\n}\n\n.ob-disclosure__content p {\n  margin: 0 0 8px;\n}\n\n.ob-disclosure__content ul {\n  margin: 0 0 8px;\n  padding-left: 18px;\n}\n\n.ob-disclosure__content li + li {\n  margin-top: 2px;\n}\n\n.ob-disclosure__content strong {\n  color: var(--text-primary);\n}\n\n/* --------------------------------------------------------------------------\n   Dropzone + file list\n   -------------------------------------------------------------------------- */\n.ob-dropzone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 28px 24px;\n  border: 1.5px dashed var(--border-strong);\n  border-radius: var(--ob-radius-lg);\n  background: var(--ob-surface-sunken);\n  color: var(--text-primary);\n  text-align: center;\n  cursor: pointer;\n  transition: border-color var(--ob-dur) var(--ob-ease), background-color var(--ob-dur) var(--ob-ease);\n}\n\n.ob-dropzone:hover:not(.is-disabled),\n.ob-dropzone.is-dragging {\n  border-color: var(--primary);\n  background: var(--primary-subtle);\n}\n\n.ob-dropzone:focus-visible {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: var(--shadow-focus);\n}\n\n.ob-dropzone.is-disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.ob-dropzone.is-invalid {\n  border-color: var(--danger);\n}\n\n.ob-dropzone__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  margin-bottom: 4px;\n  border-radius: 12px;\n  background: var(--primary-muted);\n  color: var(--primary);\n}\n\n.ob-dropzone.has-files .ob-dropzone__icon {\n  background: var(--success-muted);\n  color: var(--success);\n}\n\n.ob-dropzone__title {\n  margin: 0;\n  font-size: 14.5px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.ob-dropzone__title span {\n  color: var(--primary);\n}\n\n.ob-dropzone__hint {\n  margin: 0;\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n.ob-dropzone__formats {\n  display: inline-flex;\n  gap: 6px;\n  margin-top: 4px;\n}\n\n.ob-file-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 12px 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.ob-file-list__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 16px 0 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.ob-file {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border: 1px solid var(--border);\n  border-radius: var(--ob-radius);\n  background: var(--surface);\n}\n\n.ob-file__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  width: 34px;\n  height: 34px;\n  border-radius: var(--ob-radius-sm);\n  background: var(--info-muted);\n  color: var(--info);\n}\n\n.ob-file__icon--pdf {\n  background: var(--danger-muted);\n  color: var(--danger);\n}\n\n.ob-file__meta {\n  flex: 1;\n  min-width: 0;\n}\n\n.ob-file__name {\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 13.5px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.ob-file__sub {\n  margin: 0;\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n.ob-file__remove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  width: 30px;\n  height: 30px;\n  border: 0;\n  border-radius: var(--ob-radius-sm);\n  background: transparent;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: background-color var(--ob-dur) var(--ob-ease), color var(--ob-dur) var(--ob-ease);\n}\n\n.ob-file__remove:hover:not(:disabled) {\n  background: var(--danger-muted);\n  color: var(--danger);\n}\n\n.ob-file__remove:focus-visible {\n  outline: none;\n  box-shadow: var(--shadow-focus);\n}\n\n/* Linked/summary tile */\n.ob-tile {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  background: var(--ob-surface-sunken);\n}\n\n.ob-tile__body {\n  flex: 1;\n  min-width: 0;\n}\n\n.ob-tile__title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 650;\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ob-tile__sub {\n  margin: 2px 0 0;\n  font-size: 12.5px;\n  color: var(--text-muted);\n}\n\n/* Progress */\n.ob-progress {\n  width: 100%;\n  height: 6px;\n  border-radius: 999px;\n  background: var(--border-subtle);\n  overflow: hidden;\n}\n\n.ob-progress__fill {\n  height: 100%;\n  border-radius: inherit;\n  background: var(--primary);\n  transition: width 250ms var(--ob-ease);\n}\n\n.ob-progress-meta {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 8px;\n  font-size: 12.5px;\n  color: var(--text-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n.ob-status-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: 200px;\n  margin: 16px 0 0;\n  padding: 12px;\n  overflow-y: auto;\n  list-style: none;\n  border: 1px solid var(--border);\n  border-radius: var(--ob-radius);\n  background: var(--ob-surface-sunken);\n  text-align: left;\n}\n\n.ob-status-list li {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 12.5px;\n  line-height: 1.45;\n  color: var(--text-secondary);\n}\n\n.ob-status-list li svg {\n  flex: none;\n  margin-top: 2px;\n  color: var(--success);\n}\n\n/* --------------------------------------------------------------------------\n   Modal\n   -------------------------------------------------------------------------- */\n.ob-modal-root {\n  position: fixed;\n  inset: 0;\n  z-index: 1300;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background: rgba(2, 6, 23, 0.74);\n  animation: ob-fade 160ms var(--ob-ease) both;\n}\n\nhtml:not([data-theme='dark']) .ob-modal-root {\n  background: rgba(15, 23, 42, 0.5);\n}\n\n.ob-modal {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 520px;\n  max-height: calc(100vh - 32px);\n  max-height: calc(100dvh - 32px);\n  border: 1px solid var(--border);\n  border-radius: var(--ob-radius-xl);\n  background: var(--modal-background);\n  color: var(--text-primary);\n  box-shadow: var(--modal-shadow);\n  font-size: 14px;\n  line-height: 1.5;\n  text-align: left;\n  animation: ob-pop 180ms var(--ob-ease) both;\n  outline: none;\n}\n\n.ob-modal--sm { max-width: 440px; }\n.ob-modal--lg { max-width: 640px; }\n\n.ob-modal__header {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 24px 56px 0 24px;\n}\n\n.ob-modal__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  width: 40px;\n  height: 40px;\n  border-radius: var(--ob-radius);\n  background: var(--primary-muted);\n  color: var(--primary);\n}\n\n.ob-modal__icon--warning { background: var(--warning-muted); color: var(--warning); }\n.ob-modal__icon--danger { background: var(--danger-muted); color: var(--danger); }\n.ob-modal__icon--success { background: var(--success-muted); color: var(--success); }\n.ob-modal__icon--info { background: var(--info-muted); color: var(--info); }\n\n.ob-modal__heading {\n  min-width: 0;\n}\n\n.ob-modal__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 650;\n  line-height: 1.35;\n  color: var(--text-primary);\n}\n\n.ob-modal__desc {\n  margin: 4px 0 0;\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--text-secondary);\n}\n\n.ob-modal__close {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 0;\n  border-radius: var(--ob-radius-sm);\n  background: transparent;\n  color: var(--text-muted);\n  cursor: pointer;\n}\n\n.ob-modal__close:hover {\n  background: var(--surface-hover);\n  color: var(--text-primary);\n}\n\n.ob-modal__close:focus-visible {\n  outline: none;\n  box-shadow: var(--shadow-focus);\n}\n\n.ob-modal__body {\n  padding: 16px 24px 0;\n  overflow-y: auto;\n  color: var(--text-secondary);\n  font-size: 14px;\n}\n\n.ob-modal__body:empty {\n  display: none;\n}\n\n.ob-modal__body p {\n  margin: 0 0 12px;\n}\n\n.ob-modal__body p:last-child {\n  margin-bottom: 0;\n}\n\n.ob-modal__footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 24px;\n}\n\n.ob-modal--center .ob-modal__header {\n  flex-direction: column;\n  align-items: center;\n  padding: 32px 24px 0;\n  text-align: center;\n}\n\n.ob-modal--center .ob-modal__body {\n  text-align: center;\n}\n\n.ob-modal--center .ob-modal__footer {\n  justify-content: center;\n}\n\n.ob-kv {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 8px 16px;\n  margin: 0;\n  padding: 12px 14px;\n  border: 1px solid var(--border);\n  border-radius: var(--ob-radius);\n  background: var(--ob-surface-sunken);\n  font-size: 13.5px;\n}\n\n.ob-kv dt {\n  color: var(--text-muted);\n}\n\n.ob-kv dd {\n  margin: 0;\n  color: var(--text-primary);\n  font-weight: 600;\n  text-align: right;\n}\n\n/* Legacy in-step modals (wizard-modal-overlay / modal-overlay inside the wizard) */\n.wizard-layout .wizard-modal-overlay,\n.wizard-modal-overlay {\n  background: rgba(2, 6, 23, 0.74) !important;\n  backdrop-filter: none !important;\n}\n\nhtml:not([data-theme='dark']) .wizard-modal-overlay {\n  background: rgba(15, 23, 42, 0.5) !important;\n}\n\n.wizard-modal-overlay .wizard-modal {\n  border: 1px solid var(--border) !important;\n  border-radius: var(--ob-radius-xl, 16px) !important;\n  background: var(--modal-background) !important;\n  color: var(--text-primary) !important;\n  box-shadow: var(--modal-shadow) !important;\n}\n\n.wizard-modal-overlay .wizard-modal h2,\n.wizard-modal-overlay .wizard-modal h3,\n.wizard-modal-overlay .wizard-modal h4 {\n  color: var(--text-primary) !important;\n}\n\n/* --------------------------------------------------------------------------\n   Existing per-step building blocks (mode cards, path cards, badges…)\n   -------------------------------------------------------------------------- */\n.wizard-layout .wizard-mode-card,\n.wizard-layout .wizard-path-card,\n.wizard-layout .path-card,\n.wizard-layout .wizard-option-card {\n  border: 1px solid var(--border);\n  border-radius: var(--ob-radius-lg);\n  background: var(--surface);\n  color: var(--text-primary);\n  box-shadow: none;\n  transform: none;\n  transition: border-color var(--ob-dur) var(--ob-ease), background-color var(--ob-dur) var(--ob-ease),\n    box-shadow var(--ob-dur) var(--ob-ease);\n}\n\n.wizard-layout .wizard-mode-card:hover,\n.wizard-layout .wizard-path-card:hover,\n.wizard-layout .path-card:hover,\n.wizard-layout .wizard-option-card:hover {\n  border-color: var(--border-strong);\n  background: var(--surface-hover);\n  transform: none;\n  box-shadow: none;\n}\n\n.wizard-layout .wizard-mode-card.selected,\n.wizard-layout .wizard-path-card.selected,\n.wizard-layout .path-card.selected,\n.wizard-layout .wizard-option-card.selected {\n  border-color: var(--primary);\n  background: var(--primary-subtle);\n  box-shadow: inset 0 0 0 1px var(--primary);\n}\n\n.wizard-layout .wizard-recommended-badge {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--success-muted);\n  color: var(--success);\n  font-size: 11.5px;\n  font-weight: 600;\n  box-shadow: none;\n}\n\n.wizard-layout .wizard-progress-bar {\n  margin-bottom: 8px;\n  height: 6px;\n  border-radius: 999px;\n  background: var(--border-subtle);\n  overflow: hidden;\n}\n\n.wizard-layout .wizard-progress-fill {\n  height: 100%;\n  border-radius: inherit;\n  background: var(--primary);\n}\n\n.wizard-layout .wizard-progress-text {\n  font-size: 12.5px;\n  color: var(--text-muted);\n}\n\n.wizard-layout .wizard-logs {\n  border: 1px solid var(--border);\n  border-radius: var(--ob-radius);\n  background: var(--ob-surface-sunken);\n  color: var(--text-secondary);\n}\n\n.wizard-layout .wizard-form-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-primary);\n}\n\n.wizard-layout .wizard-form-checkbox input {\n  accent-color: var(--primary);\n}\n\n/* --------------------------------------------------------------------------\n   Dark theme: neutralise legacy hard-coded light surfaces/text in later steps.\n   (Inline styles are serialised as rgb() by the browser.)\n   -------------------------------------------------------------------------- */\nhtml[data-theme='dark'] .wizard-layout :is(\n  [style*='background-color: white'],\n  [style*='background: white'],\n  [style*='background-color: rgb(255, 255, 255)'],\n  [style*='background: rgb(255, 255, 255)'],\n  [style*='background-color: rgb(248, 249, 250)'],\n  [style*='background: rgb(248, 249, 250)'],\n  [style*='background-color: rgb(250, 250, 250)'],\n  [style*='background: rgb(250, 250, 250)'],\n  [style*='background-color: rgb(249, 250, 251)'],\n  [style*='background: rgb(249, 250, 251)'],\n  [style*='background-color: rgb(248, 250, 252)'],\n  [style*='background: rgb(248, 250, 252)'],\n  [style*='background-color: rgb(247, 247, 251)'],\n  [style*='background: rgb(247, 247, 251)']\n),\nhtml[data-theme='dark'] .wizard-modal-overlay :is(\n  [style*='background-color: white'],\n  [style*='background: white'],\n  [style*='background-color: rgb(255, 255, 255)'],\n  [style*='background: rgb(255, 255, 255)'],\n  [style*='background-color: rgb(248, 249, 250)'],\n  [style*='background: rgb(248, 249, 250)']\n) {\n  background: var(--surface-raised) !important;\n}\n\nhtml[data-theme='dark'] .wizard-layout :is(\n  [style*='background-color: rgb(240, 247, 255)'],\n  [style*='background: rgb(240, 247, 255)'],\n  [style*='background-color: rgb(239, 246, 255)'],\n  [style*='background: rgb(239, 246, 255)'],\n  [style*='background-color: rgb(232, 244, 253)'],\n  [style*='background: rgb(232, 244, 253)'],\n  [style*='background-color: rgb(227, 242, 253)'],\n  [style*='background: rgb(227, 242, 253)']\n) {\n  background: var(--info-muted) !important;\n}\n\nhtml[data-theme='dark'] .wizard-layout :is(\n  [style*='background-color: rgb(212, 237, 218)'],\n  [style*='background: rgb(212, 237, 218)'],\n  [style*='background-color: rgb(240, 253, 244)'],\n  [style*='background: rgb(240, 253, 244)'],\n  [style*='background-color: rgb(236, 253, 245)'],\n  [style*='background: rgb(236, 253, 245)']\n) {\n  background: var(--success-muted) !important;\n}\n\nhtml[data-theme='dark'] .wizard-layout :is(\n  [style*='background-color: rgb(255, 243, 205)'],\n  [style*='background: rgb(255, 243, 205)'],\n  [style*='background-color: rgb(255, 251, 235)'],\n  [style*='background: rgb(255, 251, 235)']\n) {\n  background: var(--warning-muted) !important;\n}\n\nhtml[data-theme='dark'] .wizard-layout :is(\n  [style*='background-color: rgb(233, 236, 239)'],\n  [style*='background: rgb(233, 236, 239)'],\n  [style*='background-color: rgb(241, 243, 245)'],\n  [style*='background: rgb(241, 243, 245)'],\n  [style*='background-color: rgb(243, 244, 246)'],\n  [style*='background: rgb(243, 244, 246)']\n) {\n  background: var(--bg-tertiary) !important;\n}\n\nhtml[data-theme='dark'] :is(.wizard-layout, .wizard-modal-overlay) :is(\n  [style*='color: rgb(33, 37, 41)'],\n  [style*='color: rgb(51, 51, 51)'],\n  [style*='color: rgb(17, 24, 39)'],\n  [style*='color: rgb(31, 41, 55)'],\n  [style*='color: rgb(15, 23, 42)'],\n  [style*='color: rgb(0, 0, 0)'],\n  [style*='color: black']\n):not(button) {\n  color: var(--text-primary) !important;\n}\n\nhtml[data-theme='dark'] :is(.wizard-layout, .wizard-modal-overlay) :is(\n  [style*='color: rgb(73, 80, 87)'],\n  [style*='color: rgb(102, 102, 102)'],\n  [style*='color: rgb(68, 68, 68)'],\n  [style*='color: rgb(85, 85, 85)'],\n  [style*='color: rgb(108, 117, 125)'],\n  [style*='color: rgb(75, 85, 99)'],\n  [style*='color: rgb(107, 114, 128)'],\n  [style*='color: rgb(173, 181, 189)']\n):not(button) {\n  color: var(--text-secondary) !important;\n}\n\nhtml[data-theme='dark'] .wizard-layout :is(\n  [style*='border: 1px solid rgb(222, 226, 230)'],\n  [style*='border: 1px solid rgb(229, 231, 235)'],\n  [style*='border: 1px solid rgb(204, 204, 204)'],\n  [style*='border: 1px solid rgb(221, 221, 221)'],\n  [style*='border: 1px solid rgb(233, 236, 239)']\n) {\n  border-color: var(--border) !important;\n}\n\n/* Tailwind utility leftovers inside the wizard */\nhtml[data-theme='dark'] .wizard-layout .bg-white { background-color: var(--surface-raised) !important; }\nhtml[data-theme='dark'] .wizard-layout :is(.bg-gray-50, .bg-gray-100, .bg-slate-50) { background-color: var(--bg-tertiary) !important; }\nhtml[data-theme='dark'] .wizard-layout :is(.bg-blue-50, .bg-indigo-50) { background-color: var(--info-muted) !important; }\nhtml[data-theme='dark'] .wizard-layout .bg-green-50 { background-color: var(--success-muted) !important; }\nhtml[data-theme='dark'] .wizard-layout :is(.bg-orange-50, .bg-yellow-50, .bg-amber-50) { background-color: var(--warning-muted) !important; }\nhtml[data-theme='dark'] .wizard-layout .bg-red-50 { background-color: var(--danger-muted) !important; }\nhtml[data-theme='dark'] .wizard-layout :is(.bg-blue-200, .bg-indigo-200, .bg-orange-200, .bg-gray-200) { background-color: var(--border) !important; }\nhtml[data-theme='dark'] .wizard-layout :is(.text-gray-900, .text-gray-800, .text-slate-900, .text-black) { color: var(--text-primary) !important; }\nhtml[data-theme='dark'] .wizard-layout :is(.text-gray-700, .text-gray-600, .text-slate-600) { color: var(--text-secondary) !important; }\nhtml[data-theme='dark'] .wizard-layout :is(.text-gray-500, .text-gray-400) { color: var(--text-muted) !important; }\nhtml[data-theme='dark'] .wizard-layout :is(.border-gray-200, .border-gray-300, .border-slate-200) { border-color: var(--border) !important; }\n\n/* --------------------------------------------------------------------------\n   Motion\n   -------------------------------------------------------------------------- */\n@keyframes ob-enter {\n  from { opacity: 0; transform: translateY(6px); }\n  to { opacity: 1; transform: none; }\n}\n\n@keyframes ob-pop {\n  from { opacity: 0; transform: translateY(4px) scale(0.985); }\n  to { opacity: 1; transform: none; }\n}\n\n@keyframes ob-fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes ob-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .wizard-layout *,\n  .wizard-layout *::before,\n  .wizard-layout *::after,\n  .ob-modal-root,\n  .ob-modal-root * {\n    animation-duration: 1ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 1ms !important;\n    scroll-behavior: auto !important;\n  }\n\n  .ob-spinner,\n  .wizard-layout .spinner-small {\n    animation: ob-spin 1.4s linear infinite !important;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   Responsive\n   -------------------------------------------------------------------------- */\n@media (max-width: 900px) {\n  .ob-choice-grid--3 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 720px) {\n  .wizard-layout,\n  .ob-modal-root {\n    --ob-pad-x: 20px;\n    --ob-header-h: 56px;\n  }\n\n  .wizard-layout .wizard-main {\n    padding: 0 12px;\n  }\n\n  .wizard-layout .wizard-header-content {\n    padding: 0 16px;\n  }\n\n  .wizard-layout .ob-header-tag {\n    display: none;\n  }\n\n  .wizard-layout .wizard-card-header {\n    padding-top: 22px;\n  }\n\n  .wizard-layout .wizard-card-title {\n    font-size: 22px;\n  }\n\n  .wizard-layout .wizard-card-subtitle {\n    font-size: 14px;\n  }\n\n  .wizard-layout .wizard-form-row,\n  .wizard-layout .wizard-workspace-form,\n  .ob-grid-2,\n  .ob-choice-grid--2,\n  .ob-choice-grid--3 {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .wizard-layout .wizard-card-content > .wizard-actions,\n  .wizard-layout .wizard-card-content > .wizard-workspace-actions,\n  .wizard-layout .wizard-card-content > .wizard-project-actions,\n  .wizard-layout .wizard-card-content > .ob-actions {\n    padding: 12px var(--ob-pad-x);\n  }\n\n  .ob-stepper {\n    padding-top: 12px;\n  }\n\n  .ob-stepper__percent {\n    display: none;\n  }\n\n  .ob-modal__footer {\n    flex-direction: column-reverse;\n    align-items: stretch;\n  }\n\n  .ob-modal__footer .ob-btn {\n    width: 100%;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   Step 1 hero\n   -------------------------------------------------------------------------- */\n.ob-hero {\n  max-width: 760px;\n  margin: 0 auto;\n  padding: 40px 0 28px;\n  text-align: center;\n  animation: ob-enter 220ms var(--ob-ease) both;\n}\n\n.ob-hero__eyebrow {\n  margin: 0 0 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--primary);\n}\n\n.ob-hero__title {\n  margin: 0;\n  font-size: 30px;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n  color: var(--text-primary);\n}\n\n.ob-hero__subtitle {\n  margin: 10px auto 0;\n  max-width: 620px;\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--text-secondary);\n}\n\n.ob-hero__journey {\n  display: inline-flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 8px;\n  margin: 20px 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.ob-hero__journey li {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 30px;\n  padding: 0 12px 0 4px;\n  border: 1px solid var(--border);\n  border-radius: 999px;\n  background: var(--surface);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n.ob-hero__journey li span {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: var(--bg-tertiary);\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--text-muted);\n}\n\n.ob-hero__journey li.is-active {\n  border-color: color-mix(in srgb, var(--primary) 35%, transparent);\n  color: var(--text-primary);\n}\n\n.ob-hero__journey li.is-active span {\n  background: var(--primary);\n  color: var(--ob-on-primary);\n}\n\n.wizard-layout.public .wizard-container {\n  max-width: 960px;\n}\n\n@media (max-width: 720px) {\n  .ob-hero {\n    padding: 24px 0 20px;\n  }\n\n  .ob-hero__title {\n    font-size: 24px;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   Step 4 section rhythm + project key field (wizard-scoped)\n   -------------------------------------------------------------------------- */\n.wizard-layout .wizard-path-content {\n  margin-top: 0;\n}\n\n.wizard-layout .ob-section + .wizard-path-content:not(.ob-section) > .ob-section:first-child,\n.wizard-layout .wizard-path-content > .ob-choice-grid + .ob-section {\n  margin-top: 28px;\n  padding-top: 28px;\n  border-top: 1px solid var(--border);\n}\n\n.ob-modal__header:last-child {\n  padding-bottom: 32px;\n}\n\n.wizard-layout .ob-project-key > .wizard-form-group {\n  margin: 0 !important;\n}\n\n.wizard-layout .ob-project-key .wizard-form-label {\n  font-size: 15px;\n  font-weight: 650;\n}\n\n.wizard-layout .ob-project-key code {\n  background: var(--bg-tertiary) !important;\n  color: var(--text-primary);\n  border: 1px solid var(--border);\n}\n\n.wizard-layout .ob-project-key .font-mono {\n  height: 26px;\n  padding: 0 10px !important;\n  border-radius: 999px !important;\n  font-size: 12px;\n}\n\n.wizard-layout .ob-project-key .font-mono:not(.bg-blue-600) {\n  background: var(--surface) !important;\n  border-color: var(--border) !important;\n  color: var(--text-secondary) !important;\n}\n\n.wizard-layout .ob-project-key .font-mono:not(.bg-blue-600):hover {\n  border-color: var(--primary) !important;\n  color: var(--text-primary) !important;\n}\n\n.wizard-layout .ob-project-key .font-mono.bg-blue-600 {\n  background: var(--primary) !important;\n  border-color: var(--primary) !important;\n}\n\n.wizard-layout .ob-project-key .shrink-0.rounded-md {\n  height: var(--ob-field-h) !important;\n  padding: 0 18px !important;\n  border-radius: var(--ob-radius) !important;\n  font-weight: 600 !important;\n}\n\n.wizard-layout .ob-project-key .shrink-0.rounded-md.bg-blue-600 {\n  background: var(--primary) !important;\n}\n\n.wizard-layout .ob-project-key .shrink-0.rounded-md.bg-gray-100 {\n  background: var(--surface-disabled) !important;\n  color: var(--text-muted) !important;\n  border: 1px solid var(--border);\n}\n\n.wizard-layout .ob-project-key .text-gray-500 {\n  color: var(--text-muted) !important;\n}\n\n/* --------------------------------------------------------------------------\n   Legacy variable aliases used by later steps' inline styles\n   (previously undefined → rendered transparent / inherited).\n   -------------------------------------------------------------------------- */\n.wizard-layout,\n.wizard-modal-overlay,\n.ob-modal-root {\n  --card-bg: var(--surface);\n  --background-color: var(--bg-primary);\n  --success-bg: var(--success-muted);\n  --success-color-light: var(--success-muted);\n  --info-color-light: var(--info-muted);\n  --warning-color-light: var(--warning-muted);\n  --primary-color-light: var(--primary-muted);\n  --error-color: var(--danger);\n  --error-color-light: var(--danger-muted);\n}\n\n/* Replace saturated legacy gradients with flat token colours */\n.wizard-layout :is(\n  [style*='linear-gradient(135deg, rgb(102, 126, 234)'],\n  [style*='linear-gradient(90deg, rgb(102, 126, 234)'],\n  [style*='linear-gradient(135deg, rgb(79, 172, 254)']\n),\n.wizard-modal-overlay [style*='rgb(102, 126, 234)'] {\n  background: var(--primary) !important;\n}\n\n.wizard-layout [style*='linear-gradient(135deg, rgb(240, 147, 251)'] {\n  background: var(--danger) !important;\n}\n\n.wizard-layout [style*='linear-gradient(135deg, rgba(76, 201, 240, 0.1)'] {\n  background: var(--info-muted) !important;\n}\n\n/* --------------------------------------------------------------------------\n   Summary\n   -------------------------------------------------------------------------- */\n.ob-summary-hero {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 24px;\n  padding: 16px;\n  border: 1px solid color-mix(in srgb, var(--success) 30%, transparent);\n  border-radius: var(--ob-radius-lg);\n  background: color-mix(in srgb, var(--success) 8%, var(--surface));\n}\n\n.ob-summary-hero__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  width: 52px;\n  height: 52px;\n  border-radius: 14px;\n  background: var(--success-muted);\n  color: var(--success);\n}\n\n.ob-summary-hero__title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 650;\n  color: var(--text-primary);\n}\n\n.ob-summary-hero__sub {\n  margin: 2px 0 0;\n  font-size: 13.5px;\n  color: var(--text-secondary);\n}\n\n.ob-metrics {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.ob-metric {\n  --ob-metric-color: var(--primary);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 20px;\n  border: 1px solid var(--border);\n  border-radius: var(--ob-radius-lg);\n  background: var(--surface);\n}\n\n.ob-metric--success { --ob-metric-color: var(--success); }\n.ob-metric--warning { --ob-metric-color: var(--warning); }\n\n.ob-metric__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: var(--ob-radius-sm);\n  background: color-mix(in srgb, var(--ob-metric-color) 14%, transparent);\n  color: var(--ob-metric-color);\n}\n\n.ob-metric__value {\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 1.1;\n  letter-spacing: -0.02em;\n  color: var(--text-primary);\n  font-variant-numeric: tabular-nums;\n}\n\n.ob-metric__label {\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n.ob-skeleton {\n  display: block;\n  border-radius: 6px;\n  background: var(--bg-tertiary);\n  animation: ob-pulse 1.4s ease-in-out infinite;\n}\n\n@keyframes ob-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.45; }\n}\n\n@media (max-width: 720px) {\n  .ob-metrics {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n.wizard-layout.public .wizard-footer,\n.wizard-layout.private .wizard-footer {\n  background: transparent;\n}\n\n.ob-select__option.is-placeholder {\n  font-weight: 500;\n}\n\n@media (max-width: 720px) {\n  .wizard-layout .wizard-card-content > :is(.wizard-actions, .wizard-workspace-actions, .wizard-project-actions, .ob-actions) {\n    flex-direction: row;\n    flex-wrap: nowrap;\n    gap: 8px;\n    margin-top: 24px;\n  }\n\n  .wizard-layout .wizard-card-content > :is(.wizard-actions, .wizard-workspace-actions, .wizard-project-actions, .ob-actions) > button,\n  .wizard-layout .wizard-card-content > .wizard-project-actions > div > button {\n    flex: 1 1 0;\n    width: auto;\n    min-width: 0;\n    margin: 0;\n    padding: 0 12px;\n  }\n\n  .wizard-layout .wizard-card-content > .wizard-project-actions > div {\n    flex: 2 1 0;\n    flex-wrap: nowrap !important;\n    gap: 8px !important;\n  }\n\n  .wizard-layout .wizard-card-content > :is(.wizard-actions, .wizard-workspace-actions, .wizard-project-actions, .ob-actions) > .back,\n  .wizard-layout .wizard-card-content > .wizard-actions > .wizard-btn-secondary:first-child,\n  .wizard-layout .wizard-card-content > .ob-actions > .ob-actions__start {\n    flex: 0 0 auto;\n    margin-right: 0;\n  }\n}\n\n/* ── Auth gate (/get-started/auth) ────────────────────────────────── */\n.ob-authgate {\n  display: grid;\n  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);\n  gap: 20px;\n  align-items: start;\n  max-width: 1000px;\n  margin: 8px auto 32px;\n  animation: ob-enter 280ms var(--ease-out, ease);\n}\n\n.ob-authgate__aside {\n  position: sticky;\n  top: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 26px;\n  border-radius: 16px;\n  border: 1px solid var(--border);\n  background:\n    radial-gradient(120% 80% at 0% 0%, var(--primary-subtle), transparent 60%),\n    var(--surface);\n}\n\n.ob-authgate__eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  width: fit-content;\n  height: 24px;\n  padding: 0 10px;\n  border-radius: 999px;\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--success);\n  background: var(--success-muted);\n}\n\n.ob-authgate__aside-title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 650;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n  color: var(--text-primary);\n}\n\n.ob-authgate__aside-desc {\n  margin: 0;\n  font-size: 13.5px;\n  line-height: 1.55;\n  color: var(--text-secondary);\n}\n\n.ob-authgate__next {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin: 6px 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.ob-authgate__next li {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 0;\n  font-size: 13.5px;\n  color: var(--text-secondary);\n}\n\n.ob-authgate__next li:not(:last-child)::after {\n  content: '';\n  position: absolute;\n  left: 13px;\n  top: 36px;\n  height: 12px;\n  width: 1px;\n  background: var(--border-strong);\n}\n\n.ob-authgate__next-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  color: var(--text-muted);\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-subtle);\n}\n\n.ob-authgate__next li.is-current {\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n.ob-authgate__next li.is-current .ob-authgate__next-icon {\n  color: #fff;\n  background: var(--primary);\n  border-color: transparent;\n  box-shadow: 0 0 0 4px var(--primary-muted);\n}\n\n.ob-authgate__saved {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-top: 6px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: var(--text-secondary);\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-subtle);\n}\n\n.ob-authgate__saved svg {\n  flex-shrink: 0;\n  margin-top: 1px;\n  color: var(--primary);\n}\n\n.ob-authgate__card {\n  border-radius: 16px;\n  border: 1px solid var(--border);\n  background: var(--surface);\n  box-shadow: var(--shadow-lg);\n  overflow: hidden;\n}\n\n.ob-authgate__header {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 24px 28px 18px;\n}\n\n.ob-authgate__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 11px;\n  color: var(--primary);\n  background: var(--primary-subtle);\n  border: 1px solid var(--primary-muted);\n}\n\n.ob-authgate__title {\n  margin: 0 0 2px;\n  font-size: 20px;\n  font-weight: 650;\n  letter-spacing: -0.02em;\n  color: var(--text-primary);\n}\n\n.ob-authgate__subtitle {\n  margin: 0;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.ob-authgate__tabs {\n  display: flex;\n  gap: 4px;\n  margin: 0 28px;\n  padding: 4px;\n  border-radius: 10px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n}\n\n.ob-authgate__tab {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  height: 34px;\n  border: none;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--text-secondary);\n  font: inherit;\n  font-size: 13.5px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background var(--duration-fast, 120ms) ease, color var(--duration-fast, 120ms) ease,\n    box-shadow var(--duration-fast, 120ms) ease;\n}\n\n.ob-authgate__tab:hover {\n  color: var(--text-primary);\n}\n\n.ob-authgate__tab.is-active {\n  color: var(--text-primary);\n  background: var(--surface);\n  box-shadow: var(--shadow-sm);\n}\n\n[data-theme='dark'] .ob-authgate__tab.is-active {\n  background: var(--surface-selected);\n}\n\n.ob-authgate__tab:focus-visible {\n  outline: none;\n  box-shadow: var(--shadow-focus);\n}\n\n.ob-authgate__body {\n  padding: 20px 28px 26px;\n  animation: ob-auth-fade 220ms var(--ease-out, ease);\n}\n\n@keyframes ob-auth-fade {\n  from { opacity: 0; transform: translateY(4px); }\n  to { opacity: 1; transform: none; }\n}\n\n/* Embedded Register / Login forms */\n.ob-authgate__body form {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.ob-authgate__body .form-group {\n  margin: 0;\n}\n\n.ob-authgate__body .form-label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.ob-authgate__body .form-input,\n.ob-authgate__body input[type='email'],\n.ob-authgate__body input[type='password'],\n.ob-authgate__body input[type='text'],\n.ob-authgate__body input[type='tel'] {\n  width: 100%;\n  height: 42px;\n  padding: 0 12px;\n  font-size: 14px;\n  color: var(--text-primary) !important;\n  background: var(--input-background) !important;\n  border: 1px solid var(--input-border) !important;\n  border-radius: 10px !important;\n  box-shadow: none;\n  transition: border-color var(--duration-fast, 120ms) ease, box-shadow var(--duration-fast, 120ms) ease;\n}\n\n.ob-authgate__body input::placeholder {\n  color: var(--input-placeholder) !important;\n}\n\n.ob-authgate__body .form-input:hover,\n.ob-authgate__body input:hover {\n  border-color: var(--border-strong) !important;\n}\n\n.ob-authgate__body .form-input:focus,\n.ob-authgate__body input:focus {\n  outline: none;\n  border-color: var(--primary) !important;\n  box-shadow: var(--shadow-focus) !important;\n}\n\n.ob-authgate__body .form-input.error,\n.ob-authgate__body input.error {\n  border-color: var(--danger) !important;\n}\n\n.ob-authgate__body .relative > span,\n.ob-authgate__body .relative > button,\n.ob-authgate__body .password-toggle {\n  color: var(--text-muted) !important;\n}\n\n.ob-authgate__body .form-error {\n  margin-top: 5px;\n  font-size: 12.5px;\n  color: var(--danger);\n}\n\n.ob-authgate__body .remember-me-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 2px 0 0;\n}\n\n.ob-authgate__body .remember-me-checkbox {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--primary);\n}\n\n.ob-authgate__body .remember-me-label {\n  font-size: 13px;\n  color: var(--text-secondary);\n  cursor: pointer;\n}\n\n.ob-authgate__body .btn-primary {\n  height: 42px;\n  margin-top: 4px;\n  border: none !important;\n  border-radius: 10px !important;\n  background: var(--primary) !important;\n  background-image: none !important;\n  color: #fff !important;\n  font-size: 14px;\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.1) !important;\n  transform: none !important;\n  transition: background var(--duration-fast, 120ms) ease;\n}\n\n.ob-authgate__body .btn-primary:hover:not(:disabled) {\n  background: var(--primary-hover) !important;\n}\n\n.ob-authgate__body .btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.ob-authgate__body .btn-link {\n  padding: 0;\n  border: none;\n  background: none;\n  color: var(--primary);\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n/* Login's email / phone switcher inside the gate */\n.ob-authgate__body .auth-login-tabs {\n  display: flex;\n  gap: 18px;\n  margin: 0 0 2px;\n  border-bottom: 1px solid var(--border);\n}\n\n.ob-authgate__body .auth-login-tab {\n  padding: 0 2px 9px;\n  border: none;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  background: transparent;\n  color: var(--text-muted);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.ob-authgate__body .auth-login-tab.active {\n  color: var(--text-primary);\n  border-bottom-color: var(--primary);\n}\n\n/* Registration complete view */\n.ob-authgate__body h3 {\n  color: var(--text-primary);\n  font-size: 17px;\n  font-weight: 650;\n}\n\n.ob-authgate__body p[style*='color'] {\n  color: var(--text-secondary) !important;\n}\n\n@media (max-width: 860px) {\n  .ob-authgate {\n    grid-template-columns: 1fr;\n  }\n\n  .ob-authgate__aside {\n    position: static;\n    order: 2;\n  }\n\n  .ob-authgate__next {\n    display: none;\n  }\n}\n\n@media (max-width: 520px) {\n  .ob-authgate__header,\n  .ob-authgate__body {\n    padding-left: 18px;\n    padding-right: 18px;\n  }\n\n  .ob-authgate__tabs {\n    margin: 0 18px;\n  }\n\n  .ob-authgate__body form > div[style*='grid-template-columns'] {\n    grid-template-columns: 1fr !important;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ob-authgate,\n  .ob-authgate__body {\n    animation: none;\n  }\n}\n\n.ob-authgate__body .remember-me-label,\n.ob-authgate__body .remember-me-label span {\n  white-space: normal;\n  overflow: visible;\n  text-overflow: clip;\n  line-height: 1.45;\n}\n\n.ob-authgate__body .remember-me-option {\n  align-items: flex-start;\n}\n\n.ob-authgate__body .remember-me-checkbox {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n/* Slate utilities (discovery ExecutionModeModal) */\nhtml[data-theme='dark'] .wizard-layout :is(.text-slate-900, .text-slate-800, .text-slate-700) { color: var(--text-primary) !important; }\nhtml[data-theme='dark'] .wizard-layout :is(.text-slate-600, .text-slate-500) { color: var(--text-secondary) !important; }\nhtml[data-theme='dark'] .wizard-layout .text-slate-400 { color: var(--text-muted) !important; }\nhtml[data-theme='dark'] .wizard-layout :is(.border-slate-100, .border-slate-300) { border-color: var(--border) !important; }\nhtml[data-theme='dark'] .wizard-layout :is(.hover\\:bg-slate-100:hover, .hover\\:bg-slate-50:hover) { background-color: var(--surface-hover) !important; }\nhtml[data-theme='dark'] .wizard-layout .hover\\:text-slate-600:hover { color: var(--text-primary) !important; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
